export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
  LocalDateTime: { input: any; output: any };
  Upload: { input: any; output: any };
};

export type GqlAddAuthorToPropertyListingPublicationFailure = {
  __typename?: 'AddAuthorToPropertyListingPublicationFailure';
  error: GqlGqlError;
};

export type GqlAddAuthorToPropertyListingPublicationOutput =
  | GqlAddAuthorToPropertyListingPublicationFailure
  | GqlAddAuthorToPropertyListingPublicationSuccess;

export type GqlAddAuthorToPropertyListingPublicationSuccess = {
  __typename?: 'AddAuthorToPropertyListingPublicationSuccess';
  publication: GqlPropertyListingPublication;
};

export type GqlAgent = {
  __typename?: 'Agent';
  applicationUrl: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  information: GqlAgentInformation;
  userId: Scalars['Float']['output'];
};

export type GqlAgentInformation = {
  __typename?: 'AgentInformation';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type GqlAgentsCoverageRegion = {
  __typename?: 'AgentsCoverageRegion';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type GqlAnonymousUserLoginOutputType = {
  __typename?: 'AnonymousUserLoginOutputType';
  token: Scalars['String']['output'];
};

export type GqlAppointmentAvalilabilityOutputType = {
  __typename?: 'AppointmentAvalilabilityOutputType';
  enabled: Scalars['Boolean']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  status: AppointmentStatus;
  type: AppointmentType;
  visitDate: Scalars['Float']['output'];
};

export enum AppointmentCancelationReasonCode {
  AGENTS_AVAILABILITY = 'AGENTS_AVAILABILITY',
  APPOINTMENT_RESCHEDULED = 'APPOINTMENT_RESCHEDULED',
  DESISTED_DEAL = 'DESISTED_DEAL',
  ESTATE_RESERVED = 'ESTATE_RESERVED',
  ESTATE_UNAVAILABLE_AT_VISIT_DATE = 'ESTATE_UNAVAILABLE_AT_VISIT_DATE',
  LANDLORD_AVAILABILITY = 'LANDLORD_AVAILABILITY',
  LANDLORD_COULD_NOT_BE_CONECTED = 'LANDLORD_COULD_NOT_BE_CONECTED',
  LANDLORD_IS_EVALUATING_A_TENANT = 'LANDLORD_IS_EVALUATING_A_TENANT',
  LANDLORD_STILL_NOT_ACCEPT_TERMS_AND_CONDITIONS = 'LANDLORD_STILL_NOT_ACCEPT_TERMS_AND_CONDITIONS',
  MAX_PENDING_TIME_REACHED = 'MAX_PENDING_TIME_REACHED',
  OTHER = 'OTHER',
  REQUESTED_BY_TENANT = 'REQUESTED_BY_TENANT',
  TENANT_AVAILABILITY = 'TENANT_AVAILABILITY',
  TENANT_DID_NOT_ANSWERED = 'TENANT_DID_NOT_ANSWERED',
}

export type GqlAppointmentCancelationReasonInputType = {
  code: AppointmentCancelationReasonCode;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type GqlAppointmentEstateInput = {
  baseVisitConsiderations?: InputMaybe<Scalars['String']['input']>;
  isLandlordConfirmationNeeded: Scalars['Boolean']['input'];
};

export type GqlAppointmentEstateOutputType = {
  __typename?: 'AppointmentEstateOutputType';
  address: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  legalId: Scalars['String']['output'];
  pricing: GqlEstatePricingOutputType;
};

export type GqlAppointmentEstateType = {
  __typename?: 'AppointmentEstateType';
  baseVisitConsiderations?: Maybe<Scalars['String']['output']>;
  isLandlordConfirmationNeeded: Scalars['Boolean']['output'];
};

export type GqlAppointmentOutputType = {
  __typename?: 'AppointmentOutputType';
  estate: GqlAppointmentEstateOutputType;
  id: Scalars['Int']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  landlordName?: Maybe<Scalars['String']['output']>;
  landlordPhone?: Maybe<Scalars['String']['output']>;
  status: AppointmentStatus;
  suggestedInstructions?: Maybe<Scalars['String']['output']>;
  tenant: GqlAppointmentUserType;
  type: AppointmentType;
  visitAssistant?: Maybe<GqlAppointmentUserType>;
  visitCompanion?: Maybe<GqlAppointmentUserType>;
  visitDate: Scalars['Float']['output'];
};

export enum AppointmentStatus {
  BEING_CONFIRMED_BY_LANDLORD = 'BEING_CONFIRMED_BY_LANDLORD',
  BEING_CONFIRMED_BY_VISIT_COMPANIONS = 'BEING_CONFIRMED_BY_VISIT_COMPANIONS',
  CANCELED = 'CANCELED',
  CONFIRMED = 'CONFIRMED',
  CREATED = 'CREATED',
  EXPIRED = 'EXPIRED',
  LANDLORD_CONFIRMED = 'LANDLORD_CONFIRMED',
  VISITED = 'VISITED',
  VISIT_COMPANION_AGENT_CONFIRMED = 'VISIT_COMPANION_AGENT_CONFIRMED',
}

export enum AppointmentType {
  FACE_2_FACE_ALONE = 'FACE_2_FACE_ALONE',
  FACE_2_FACE_MULTIPLE = 'FACE_2_FACE_MULTIPLE',
  VIRTUAL = 'VIRTUAL',
}

export type GqlAppointmentUserInputType = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  identityDocumentCode: Scalars['String']['input'];
  identityDocumentType: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlAppointmentUserType = {
  __typename?: 'AppointmentUserType';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  identityDocumentCode?: Maybe<Scalars['String']['output']>;
  identityDocumentType?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phoneCode: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum AuthChannel {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
}

export type GqlB2bLandlordType = {
  assetAcount: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  landlordId: Scalars['Int']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type GqlBatchPutPropertyListingPublicationAttributeOutput =
  | GqlBatchPutPropertyListingPublicationAttributesFailure
  | GqlBatchPutPropertyListingPublicationAttributesSuccess;

export type GqlBatchPutPropertyListingPublicationAttributesFailure = {
  __typename?: 'BatchPutPropertyListingPublicationAttributesFailure';
  error: GqlGqlError;
};

export type GqlBatchPutPropertyListingPublicationAttributesSuccess = {
  __typename?: 'BatchPutPropertyListingPublicationAttributesSuccess';
  publication: Array<GqlPropertyListingPublication>;
};

export type GqlBenefitsInputType = {
  id?: InputMaybe<Scalars['Int']['input']>;
  items: Array<EstateBenefitCode>;
};

export enum BrokerBusinessKind {
  RENT = 'RENT',
  RENT_AND_SELL = 'RENT_AND_SELL',
  SELL = 'SELL',
}

export enum BusinessModel {
  B2B = 'B2B',
  B2C = 'B2C',
}

export type GqlCalculationMethodType = {
  __typename?: 'CalculationMethodType';
  method: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GqlCapturingAgentDocumentInputType = {
  capturingAgentId?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  uri: Scalars['String']['input'];
};

export type GqlCapturingAgentDocumentOutputType = {
  __typename?: 'CapturingAgentDocumentOutputType';
  capturingAgentId?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type GqlCapturingManagerInputType = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  identityDocumentCode: Scalars['String']['input'];
  identityDocumentType: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlCapturingManagerOutputType = {
  __typename?: 'CapturingManagerOutputType';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  idCapturingManager?: Maybe<Scalars['Int']['output']>;
  identityDocumentCode?: Maybe<Scalars['String']['output']>;
  identityDocumentType?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phoneCode: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

export type GqlCategoryOutputType = {
  __typename?: 'CategoryOutputType';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type GqlCharacteristicSearchFilter = {
  slug?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCommandResponseOutputType = {
  __typename?: 'CommandResponseOutputType';
  value: Scalars['String']['output'];
};

export type GqlComparableQualityIndexOutputType = {
  __typename?: 'ComparableQualityIndexOutputType';
  allowedDeviation: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
};

export type GqlCompletedAppointmentOutputType = {
  __typename?: 'CompletedAppointmentOutputType';
  estate: GqlAppointmentEstateOutputType;
  id: Scalars['Float']['output'];
  tenantUserId: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  visitCompanionAgent: Scalars['String']['output'];
  visitDate: Scalars['Float']['output'];
};

export type GqlCoordinatesType = {
  __typename?: 'CoordinatesType';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GqlCreateAppointmentDealInputType = {
  estateId: Scalars['String']['input'];
};

export type GqlCreateAppointmentEstateType = {
  baseVisitConsiderations?: InputMaybe<Scalars['String']['input']>;
  estateId: Scalars['Float']['input'];
  isLandlordConfirmationNeeded: Scalars['Boolean']['input'];
};

export type GqlCreateAppointmentInputType = {
  estateId: Scalars['Int']['input'];
  tenant: Scalars['Int']['input'];
  type: AppointmentType;
  visitAssistant?: InputMaybe<GqlAppointmentUserInputType>;
  visitDate: Scalars['Float']['input'];
};

export type GqlCreateDealSupplyOutputType = {
  __typename?: 'CreateDealSupplyOutputType';
  addres?: Maybe<Scalars['String']['output']>;
  amountOfBathrooms?: Maybe<Scalars['Float']['output']>;
  amountOfBedrooms?: Maybe<Scalars['Float']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  autoPublish: Scalars['Boolean']['output'];
  campaign?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  crmDealId?: Maybe<Scalars['String']['output']>;
  dealName: Scalars['String']['output'];
  furnished?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  landlordPhone: Scalars['String']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  origin: Scalars['String']['output'];
  parkingOptions?: Maybe<Scalars['Float']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  sourceChannel?: Maybe<Scalars['String']['output']>;
  stage: Scalars['String']['output'];
  stratum?: Maybe<Scalars['Float']['output']>;
  suggested_price?: Maybe<Scalars['String']['output']>;
};

export type GqlCreateDealType = {
  address?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Scalars['Int']['input']>;
  bathRoomsNr?: InputMaybe<Scalars['Int']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  furnished?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  leadOrigin: HubspotSource;
  longitude?: InputMaybe<Scalars['String']['input']>;
  parkingLotOptions?: InputMaybe<Scalars['Int']['input']>;
  phone: Scalars['String']['input'];
  roomsNr?: InputMaybe<Scalars['Int']['input']>;
  stratum?: InputMaybe<Scalars['Int']['input']>;
  suggestedPrice?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

export type GqlCreatePropertyListingPublicationFailure = {
  __typename?: 'CreatePropertyListingPublicationFailure';
  error: GqlGqlError;
};

export type GqlCreatePropertyListingPublicationOutput =
  | GqlCreatePropertyListingPublicationFailure
  | GqlCreatePropertyListingPublicationSuccess;

export type GqlCreatePropertyListingPublicationSuccess = {
  __typename?: 'CreatePropertyListingPublicationSuccess';
  publication: GqlPropertyListingPublication;
};

export type GqlCreatePropertyListingPublicationUploadMediaUrlFailure = {
  __typename?: 'CreatePropertyListingPublicationUploadMediaUrlFailure';
  error: GqlGqlError;
};

export type GqlCreatePropertyListingPublicationUploadMediaUrlOutput =
  | GqlCreatePropertyListingPublicationUploadMediaUrlFailure
  | GqlCreatePropertyListingPublicationUploadMediaUrlSuccess;

export type GqlCreatePropertyListingPublicationUploadMediaUrlSuccess = {
  __typename?: 'CreatePropertyListingPublicationUploadMediaUrlSuccess';
  attachmentId: Scalars['String']['output'];
  uploadPath: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type GqlCreateUserInputType = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identityDocumentCode?: InputMaybe<Scalars['String']['input']>;
  identityDocumentType?: InputMaybe<IdentityDocumentType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export enum CurrencyType {
  ARS = 'ARS',
  COP = 'COP',
  EUR = 'EUR',
  MXN = 'MXN',
  USD = 'USD',
}

export type GqlDayAvailabilityOutputType = {
  __typename?: 'DayAvailabilityOutputType';
  date: Scalars['Float']['output'];
  slots: Array<GqlSlotAvailabilityOutputType>;
  weekDay: Scalars['String']['output'];
};

export type GqlDiscardsResponse = {
  __typename?: 'DiscardsResponse';
  count: Scalars['Int']['output'];
  discards: Array<GqlUserPropertyDiscard>;
  error: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type GqlDocumentOutputType = {
  __typename?: 'DocumentOutputType';
  documentationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: DocumentType;
  uri: Scalars['String']['output'];
};

export enum DocumentType {
  BANK_STATEMENT = 'BANK_STATEMENT',
  CHAMBER_OF_COMMERCE = 'CHAMBER_OF_COMMERCE',
  DNI = 'DNI',
  EMPLOYMENT_CERTIFICATION = 'EMPLOYMENT_CERTIFICATION',
  INCOME_CERTIFICATION = 'INCOME_CERTIFICATION',
  PENSION_CERTIFICATION = 'PENSION_CERTIFICATION',
  RENT_DECLARATION = 'RENT_DECLARATION',
  RUT = 'RUT',
  SIGNED_FINANCIAL_STATUS = 'SIGNED_FINANCIAL_STATUS',
}

export type GqlDocumentationOutputType = {
  __typename?: 'DocumentationOutputType';
  creditStudyId: Scalars['String']['output'];
  documents: Array<GqlDocumentOutputType>;
  id: Scalars['String']['output'];
  isComplete: Scalars['Boolean']['output'];
  requiredDocuments: Array<DocumentType>;
  status: DocumentationStatus;
  type: DocumentationType;
  userId: Scalars['Float']['output'];
};

export enum DocumentationStatus {
  APPROVED = 'APPROVED',
  DOCUMENTS_REJECTED = 'DOCUMENTS_REJECTED',
  EXPIRED = 'EXPIRED',
  PRISTINE = 'PRISTINE',
  REVIEW_PENDING = 'REVIEW_PENDING',
}

export enum DocumentationType {
  EMPLOYED = 'EMPLOYED',
  INDEPENDENT = 'INDEPENDENT',
  LEGAL_PERSON = 'LEGAL_PERSON',
  PENSIONER = 'PENSIONER',
  UNKNOWN = 'UNKNOWN',
}

export type GqlEstateAgentType = {
  __typename?: 'EstateAgentType';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  identityDocumentCode?: Maybe<Scalars['String']['output']>;
  identityDocumentType?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export enum EstateBenefitCode {
  ALL_RISK_INSURANCE = 'ALL_RISK_INSURANCE',
  CLEANING_SERVICE = 'CLEANING_SERVICE',
  CO_PROPERTY_REPRESENTATION = 'CO_PROPERTY_REPRESENTATION',
  DAMAGE_MISSING_INSURANCE = 'DAMAGE_MISSING_INSURANCE',
  ELECTRONIC_LOCK = 'ELECTRONIC_LOCK',
  GET_LIQUIDITY = 'GET_LIQUIDITY',
  HEARTHQUAKE_COVERAGE = 'HEARTHQUAKE_COVERAGE',
  IMPROVE_SEO = 'IMPROVE_SEO',
  KEYS_BOX = 'KEYS_BOX',
  PAINTING_SERVICE = 'PAINTING_SERVICE',
  PROFESIONAL_PHOTOS = 'PROFESIONAL_PHOTOS',
  PROFILE_CHECK = 'PROFILE_CHECK',
  PUBLIC_SERVICES_PAYMENT = 'PUBLIC_SERVICES_PAYMENT',
  RENT_ADVANCE = 'RENT_ADVANCE',
  RENT_SINCE_PUBLICATION = 'RENT_SINCE_PUBLICATION',
  TIMELY_PAYMENT_12 = 'TIMELY_PAYMENT_12',
  TIMELY_PAYMENT_36 = 'TIMELY_PAYMENT_36',
  VISIT_ASSISTANT = 'VISIT_ASSISTANT',
}

export type GqlEstateCharacteristic = {
  allowPets?: InputMaybe<Scalars['Boolean']['input']>;
  allowPriceNegociation?: InputMaybe<Scalars['Boolean']['input']>;
  amountOfBathrooms?: InputMaybe<Scalars['Int']['input']>;
  amountOfBedrooms?: InputMaybe<Scalars['Int']['input']>;
  amountOfClosets?: InputMaybe<Scalars['Int']['input']>;
  amountOfElevators?: InputMaybe<Scalars['Float']['input']>;
  amountOfFloors?: InputMaybe<Scalars['Int']['input']>;
  amountOfParkings?: InputMaybe<Scalars['Int']['input']>;
  antiqueness?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<Scalars['Float']['input']>;
  builtArea?: InputMaybe<Scalars['Float']['input']>;
  canAccessPersonsWithReducedMobility?: InputMaybe<Scalars['Boolean']['input']>;
  curtains?: InputMaybe<Scalars['String']['input']>;
  deposit?: InputMaybe<Scalars['Boolean']['input']>;
  hasAlarm?: InputMaybe<Scalars['Boolean']['input']>;
  hasBalcony?: InputMaybe<Scalars['Boolean']['input']>;
  hasBasketField?: InputMaybe<Scalars['Boolean']['input']>;
  hasBbqZones?: InputMaybe<Scalars['Boolean']['input']>;
  hasChildrenZones?: InputMaybe<Scalars['Boolean']['input']>;
  hasCommonLaundryZones?: InputMaybe<Scalars['Boolean']['input']>;
  hasComunalLiving?: InputMaybe<Scalars['Boolean']['input']>;
  hasElevator?: InputMaybe<Scalars['Boolean']['input']>;
  hasFirePlace?: InputMaybe<Scalars['Boolean']['input']>;
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>;
  hasGreenZones?: InputMaybe<Scalars['Boolean']['input']>;
  hasGym?: InputMaybe<Scalars['Boolean']['input']>;
  hasHall?: InputMaybe<Scalars['Boolean']['input']>;
  hasHeating?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndoorGarden?: InputMaybe<Scalars['Boolean']['input']>;
  hasIndoorParking?: InputMaybe<Scalars['Boolean']['input']>;
  hasInterphone?: InputMaybe<Scalars['Boolean']['input']>;
  hasJacuzzi?: InputMaybe<Scalars['Boolean']['input']>;
  hasLaundryZones?: InputMaybe<Scalars['Boolean']['input']>;
  hasNaturalGas?: InputMaybe<Scalars['Boolean']['input']>;
  hasPanoramicView?: InputMaybe<Scalars['Boolean']['input']>;
  hasSafetyDoor?: InputMaybe<Scalars['Boolean']['input']>;
  hasSauna?: InputMaybe<Scalars['Boolean']['input']>;
  hasServiceRoom?: InputMaybe<Scalars['Boolean']['input']>;
  hasSoccerField?: InputMaybe<Scalars['Boolean']['input']>;
  hasSquashField?: InputMaybe<Scalars['Boolean']['input']>;
  hasStudy?: InputMaybe<Scalars['Boolean']['input']>;
  hasSwimmingPool?: InputMaybe<Scalars['Boolean']['input']>;
  hasTennisField?: InputMaybe<Scalars['Boolean']['input']>;
  hasTerrace?: InputMaybe<Scalars['Boolean']['input']>;
  hasTvSurveillance?: InputMaybe<Scalars['Boolean']['input']>;
  hasYard?: InputMaybe<Scalars['Boolean']['input']>;
  internalNumber?: InputMaybe<Scalars['Int']['input']>;
  isAclosedUnit?: InputMaybe<Scalars['Boolean']['input']>;
  isFurnished?: InputMaybe<Scalars['Boolean']['input']>;
  isHighDemand?: InputMaybe<Scalars['Boolean']['input']>;
  isMallNearby?: InputMaybe<Scalars['Boolean']['input']>;
  isNearbyPrincipalWay?: InputMaybe<Scalars['Boolean']['input']>;
  isNearbySecondaryWay?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  isParkNearby?: InputMaybe<Scalars['Boolean']['input']>;
  isSchoolNearby?: InputMaybe<Scalars['Boolean']['input']>;
  isSupermarketNearby?: InputMaybe<Scalars['Boolean']['input']>;
  isTransportNearby?: InputMaybe<Scalars['Boolean']['input']>;
  kindNaturalGas?: InputMaybe<Scalars['String']['input']>;
  kindOfEstate?: InputMaybe<Scalars['String']['input']>;
  kindOfHeating?: InputMaybe<Scalars['String']['input']>;
  kindOfKitchen?: InputMaybe<Scalars['String']['input']>;
  kindOfParking?: InputMaybe<Scalars['String']['input']>;
  kindOfTerraceOrBalcony?: InputMaybe<Scalars['String']['input']>;
  large?: InputMaybe<Scalars['Float']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  numberOfApartment?: InputMaybe<Scalars['Int']['input']>;
  numberOfFloor?: InputMaybe<Scalars['Int']['input']>;
  petsAllowed?: InputMaybe<Scalars['String']['input']>;
  stratum?: InputMaybe<Scalars['Int']['input']>;
  terraceArea?: InputMaybe<Scalars['Float']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
  whatsappContact?: InputMaybe<Scalars['String']['input']>;
};

export type GqlEstateCharacteristicsType = {
  __typename?: 'EstateCharacteristicsType';
  allowPets: Scalars['Boolean']['output'];
  allowPriceNegociation: Scalars['Boolean']['output'];
  amountOfBathrooms?: Maybe<Scalars['Int']['output']>;
  amountOfBedrooms?: Maybe<Scalars['Int']['output']>;
  amountOfClosets?: Maybe<Scalars['Int']['output']>;
  amountOfElevators?: Maybe<Scalars['Int']['output']>;
  amountOfFloors?: Maybe<Scalars['Int']['output']>;
  amountOfParkings?: Maybe<Scalars['Int']['output']>;
  antiqueness?: Maybe<Scalars['String']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  builtArea?: Maybe<Scalars['Float']['output']>;
  canAccessPersonsWithReducedMobility: Scalars['Boolean']['output'];
  curtains?: Maybe<Scalars['String']['output']>;
  deposit: Scalars['Boolean']['output'];
  hasAlarm: Scalars['Boolean']['output'];
  hasBalcony: Scalars['Boolean']['output'];
  hasBasketField: Scalars['Boolean']['output'];
  hasBbqZones: Scalars['Boolean']['output'];
  hasChildrenZones: Scalars['Boolean']['output'];
  hasCommonLaundryZones: Scalars['Boolean']['output'];
  hasComunalLiving: Scalars['Boolean']['output'];
  hasElevator: Scalars['Boolean']['output'];
  hasFirePlace: Scalars['Boolean']['output'];
  hasGarden: Scalars['Boolean']['output'];
  hasGreenZones: Scalars['Boolean']['output'];
  hasGym: Scalars['Boolean']['output'];
  hasHall: Scalars['Boolean']['output'];
  hasHeating: Scalars['Boolean']['output'];
  hasIndoorGarden: Scalars['Boolean']['output'];
  hasIndoorParking: Scalars['Boolean']['output'];
  hasInterphone: Scalars['Boolean']['output'];
  hasJacuzzi: Scalars['Boolean']['output'];
  hasLaundryZones: Scalars['Boolean']['output'];
  hasNaturalGas: Scalars['Boolean']['output'];
  hasPanoramicView: Scalars['Boolean']['output'];
  hasSafetyDoor: Scalars['Boolean']['output'];
  hasSauna: Scalars['Boolean']['output'];
  hasServiceRoom: Scalars['Boolean']['output'];
  hasSoccerField: Scalars['Boolean']['output'];
  hasSquashField: Scalars['Boolean']['output'];
  hasStudy: Scalars['Boolean']['output'];
  hasSwimmingPool: Scalars['Boolean']['output'];
  hasTennisField: Scalars['Boolean']['output'];
  hasTerrace: Scalars['Boolean']['output'];
  hasTvSurveillance: Scalars['Boolean']['output'];
  hasYard: Scalars['Boolean']['output'];
  internalNumber?: Maybe<Scalars['Int']['output']>;
  isAclosedUnit: Scalars['Boolean']['output'];
  isFurnished: Scalars['Boolean']['output'];
  isHighDemand: Scalars['Boolean']['output'];
  isMallNearby: Scalars['Boolean']['output'];
  isNearbyPrincipalWay: Scalars['Boolean']['output'];
  isNearbySecondaryWay: Scalars['Boolean']['output'];
  isNew: Scalars['Boolean']['output'];
  isParkNearby: Scalars['Boolean']['output'];
  isSchoolNearby: Scalars['Boolean']['output'];
  isSupermarketNearby: Scalars['Boolean']['output'];
  isTransportNearby: Scalars['Boolean']['output'];
  kindOfEstate?: Maybe<Scalars['String']['output']>;
  kindOfHeating?: Maybe<Scalars['String']['output']>;
  kindOfKitchen?: Maybe<Scalars['String']['output']>;
  kindOfParking?: Maybe<Scalars['String']['output']>;
  kindOfTerraceOrBalcony?: Maybe<Scalars['String']['output']>;
  large?: Maybe<Scalars['Float']['output']>;
  naturalGas?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  numberOfApartment?: Maybe<Scalars['Int']['output']>;
  numberOfFloor?: Maybe<Scalars['Int']['output']>;
  petsAllowed?: Maybe<Scalars['String']['output']>;
  stratum?: Maybe<Scalars['String']['output']>;
  terraceArea?: Maybe<Scalars['Float']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  view?: Maybe<Scalars['String']['output']>;
  whatsappContact?: Maybe<Scalars['String']['output']>;
};

export type GqlEstateInput = {
  about: Scalars['String']['input'];
  address: Scalars['String']['input'];
  addressDetails?: InputMaybe<Scalars['String']['input']>;
  administrationPrice?: InputMaybe<Scalars['Int']['input']>;
  appointmentEstateInformation?: InputMaybe<GqlAppointmentEstateInput>;
  benefitsId?: InputMaybe<Scalars['Int']['input']>;
  businessModel?: InputMaybe<BusinessModel>;
  characteristics?: InputMaybe<GqlEstateCharacteristic>;
  currency: CurrencyType;
  estateType: EstateType;
  id?: InputMaybe<Scalars['Int']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  origin?: InputMaybe<EstateOriginType>;
  price: Scalars['Int']['input'];
  status?: InputMaybe<EstateStatus>;
};

export type GqlEstateLandlordType = {
  __typename?: 'EstateLandlordType';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  identityDocumentCode?: Maybe<Scalars['String']['output']>;
  identityDocumentType?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type GqlEstateLocationParentsOutputType = {
  __typename?: 'EstateLocationParentsOutputType';
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  locationSlug: Scalars['String']['output'];
};

export enum EstateLocationType {
  COUNTRY = 'COUNTRY',
  LOCATION_LEVEL_2 = 'LOCATION_LEVEL_2',
  LOCATION_LEVEL_3 = 'LOCATION_LEVEL_3',
  LOCATION_LEVEL_4 = 'LOCATION_LEVEL_4',
  LOCATION_LEVEL_5 = 'LOCATION_LEVEL_5',
  LOCATION_LEVEL_6 = 'LOCATION_LEVEL_6',
  LOCATION_LEVEL_7 = 'LOCATION_LEVEL_7',
  LOCATION_LEVEL_8 = 'LOCATION_LEVEL_8',
  LOCATION_LEVEL_9 = 'LOCATION_LEVEL_9',
  LOCATION_LEVEL_10 = 'LOCATION_LEVEL_10',
  LOCATION_LEVEL_11 = 'LOCATION_LEVEL_11',
  LOCATION_LEVEL_12 = 'LOCATION_LEVEL_12',
  LOCATION_LEVEL_13 = 'LOCATION_LEVEL_13',
  LOCATION_LEVEL_14 = 'LOCATION_LEVEL_14',
  LOCATION_LEVEL_15 = 'LOCATION_LEVEL_15',
  LOCATION_LEVEL_16 = 'LOCATION_LEVEL_16',
  LOCATION_LEVEL_17 = 'LOCATION_LEVEL_17',
  LOCATION_LEVEL_19 = 'LOCATION_LEVEL_19',
  LOCATION_LEVEL_20 = 'LOCATION_LEVEL_20',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
}

export type GqlEstateMediaType = {
  __typename?: 'EstateMediaType';
  format: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isPrincipal: Scalars['Boolean']['output'];
  uri: Scalars['String']['output'];
};

export enum EstateOriginType {
  AUTOPUBLISH = 'AUTOPUBLISH',
  B2B = 'B2B',
  WITHOUT_PUBLICATION = 'WITHOUT_PUBLICATION',
}

export type GqlEstateOutputTypeGql = {
  __typename?: 'EstateOutputTypeGQL';
  address: Scalars['String']['output'];
  createdAt: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  legalId: Scalars['String']['output'];
  managementPlan?: Maybe<TermsAndConditionsTypeEnum>;
  pricing: GqlEstatePricingOutputTypeGql;
  status: EstateStatus;
  visitInstructions?: Maybe<Scalars['String']['output']>;
};

export type GqlEstatePricingOutputType = {
  __typename?: 'EstatePricingOutputType';
  admonPrice: Scalars['Float']['output'];
  currencyISO: Scalars['String']['output'];
  quote: Scalars['Float']['output'];
};

export type GqlEstatePricingOutputTypeGql = {
  __typename?: 'EstatePricingOutputTypeGQL';
  admon: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  lease: Scalars['Float']['output'];
};

export enum EstatePublicationType {
  COMMERCIAL = 'COMMERCIAL',
  RESIDENTIAL = 'RESIDENTIAL',
}

export type GqlEstateRecommendationType = {
  __typename?: 'EstateRecommendationType';
  calculationMethod: GqlCalculationMethodType;
  kind: Scalars['String']['output'];
  recommendedEstates: Array<GqlRecommendedEstateType>;
};

export enum EstateStatus {
  BANNED = 'BANNED',
  CONSIGNED = 'CONSIGNED',
  LEASED = 'LEASED',
  PAUSED = 'PAUSED',
  PUBLISHED = 'PUBLISHED',
  REGISTERED = 'REGISTERED',
  RESERVED = 'RESERVED',
}

export enum EstateType {
  APARTMENT = 'APARTMENT',
  HOUSE = 'HOUSE',
}

export type GqlEstateVisitAvailabilityInputType = {
  estateId: Scalars['Int']['input'];
  slots?: Array<GqlSlotAvailabilityInputType>;
};

export type GqlEstateVisitAvailabilityOutputType = {
  __typename?: 'EstateVisitAvailabilityOutputType';
  availability: Array<GqlDayAvailabilityOutputType>;
  estateId: Scalars['Int']['output'];
  recommended: Array<GqlDayAvailabilityOutputType>;
};

export type GqlEstatesSearchFilterType = {
  characteristics?: InputMaybe<
    Array<InputMaybe<GqlCharacteristicSearchFilter>>
  >;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  locationSlug?: InputMaybe<Scalars['String']['input']>;
  maxArea?: InputMaybe<Scalars['Int']['input']>;
  maxPrice?: InputMaybe<Scalars['Int']['input']>;
  minArea?: InputMaybe<Scalars['Int']['input']>;
  minBathrooms?: InputMaybe<Scalars['Int']['input']>;
  minGarajes?: InputMaybe<Scalars['Int']['input']>;
  minPrice?: InputMaybe<Scalars['Int']['input']>;
  minRooms?: InputMaybe<Scalars['Int']['input']>;
  propertyAge?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<Scalars['String']['input']>;
  stratum?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum EstimatedMoveDate {
  AS_SOON_AS_POSSIBLE = 'AS_SOON_AS_POSSIBLE',
  DONT_KNOW = 'DONT_KNOW',
  NEXT_MONTH = 'NEXT_MONTH',
  NEXT_SEVEN_DAYS = 'NEXT_SEVEN_DAYS',
}

export type GqlExposedDocumentOutputType = {
  __typename?: 'ExposedDocumentOutputType';
  documentationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: DocumentType;
};

export type GqlExposedDocumentationOutputType = {
  __typename?: 'ExposedDocumentationOutputType';
  creditStudyId: Scalars['String']['output'];
  documents: Array<GqlExposedDocumentOutputType>;
  id: Scalars['String']['output'];
  isComplete: Scalars['Boolean']['output'];
  requiredDocuments: Array<DocumentType>;
  status: DocumentationStatus;
  type: DocumentationType;
  userId: Scalars['Float']['output'];
};

export type GqlExposedEstateOutputType = {
  __typename?: 'ExposedEstateOutputType';
  address: Scalars['String']['output'];
  addressDetails?: Maybe<Scalars['String']['output']>;
  agent?: Maybe<GqlEstateAgentType>;
  agentId?: Maybe<Scalars['Float']['output']>;
  agentUserId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  landlord?: Maybe<GqlEstateLandlordType>;
  landlordId: Scalars['Float']['output'];
  landlordUserId?: Maybe<Scalars['Float']['output']>;
  legalId: Scalars['String']['output'];
};

export type GqlFavsResponse = {
  __typename?: 'FavsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['Boolean']['output']>;
  favs?: Maybe<Array<GqlUserPropertyFav>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type GqlFilterPricing = {
  __typename?: 'FilterPricing';
  options: Array<GqlFilterPricingOptions>;
};

export type GqlFilterPricingOptionValue = {
  __typename?: 'FilterPricingOptionValue';
  priceMax: Scalars['Int']['output'];
  priceMin?: Maybe<Scalars['Int']['output']>;
};

export type GqlFilterPricingOptions = {
  __typename?: 'FilterPricingOptions';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  value: GqlFilterPricingOptionValue;
};

export type GqlFilterRooms = {
  __typename?: 'FilterRooms';
  options: Array<GqlFilterRoomsOptions>;
};

export type GqlFilterRoomsOptions = {
  __typename?: 'FilterRoomsOptions';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlFilters = {
  __typename?: 'Filters';
  aggregations: Array<GqlSearchFilterAggregation>;
  availableLocations: Array<GqlSearchableLocation>;
  currentBranch?: Maybe<Array<GqlSearchableLocation>>;
  pricing: GqlFilterPricing;
  rooms: GqlFilterRooms;
};

export type GqlFullEstateType = {
  __typename?: 'FullEstateType';
  address: Scalars['String']['output'];
  addressDetails?: Maybe<Scalars['String']['output']>;
  appointmentEstateInformation?: Maybe<GqlAppointmentEstateType>;
  characteristics: GqlEstateCharacteristicsType;
  description: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  isExclusive: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  latitude: Scalars['Float']['output'];
  legalId?: Maybe<Scalars['String']['output']>;
  location: GqlLocationType;
  longitude: Scalars['Float']['output'];
  media: Array<GqlEstateMediaType>;
  pricing: GqlPriceType;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GqlGeneralEstatePublicationQualityOutputType = {
  __typename?: 'GeneralEstatePublicationQualityOutputType';
  addressFormat: Scalars['String']['output'];
  amountOfPictures: GqlComparableQualityIndexOutputType;
  descriptionLength: GqlComparableQualityIndexOutputType;
};

export type GqlGetAgentBySlugFailure = {
  __typename?: 'GetAgentBySlugFailure';
  error: GqlGqlError;
};

export type GqlGetAgentBySlugOutputType =
  | GqlGetAgentBySlugFailure
  | GqlGetAgentBySlugSuccess;

export type GqlGetAgentBySlugSuccess = {
  __typename?: 'GetAgentBySlugSuccess';
  agent: GqlAgent;
};

export type GqlGetPropertyListingPublicationFailure = {
  __typename?: 'GetPropertyListingPublicationFailure';
  error: GqlGqlError;
};

export type GqlGetPropertyListingPublicationOutput =
  | GqlGetPropertyListingPublicationFailure
  | GqlGetPropertyListingPublicationSuccess;

export type GqlGetPropertyListingPublicationSuccess = {
  __typename?: 'GetPropertyListingPublicationSuccess';
  publication: GqlPropertyListingPublication;
};

export type GqlGqlError = {
  __typename?: 'GqlError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  metadata: Array<GqlGqlErrorMetadataItem>;
};

export type GqlGqlErrorMetadataItem = {
  __typename?: 'GqlErrorMetadataItem';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum HubspotSource {
  APTUNO = 'APTUNO',
  AUTOPUBLISH = 'AUTOPUBLISH',
  B2B = 'B2B',
  BY_CAPTURING_AGENT = 'BY_CAPTURING_AGENT',
  BY_LANDLORD = 'BY_LANDLORD',
  FINCARAIZ = 'FINCARAIZ',
  FINCARAIZ_RETRY = 'FINCARAIZ_RETRY',
  INMUEBLES24 = 'INMUEBLES24',
  INMUEBLES24_RETRY = 'INMUEBLES24_RETRY',
  MADE_BY_CAPTURING_AGENT = 'MADE_BY_CAPTURING_AGENT',
  METROCUADRADO = 'METROCUADRADO',
  METROCUADRADO_RETRY = 'METROCUADRADO_RETRY',
  PROPERATI = 'PROPERATI',
  RENT_CALCULATOR = 'RENT_CALCULATOR',
  SEGUNDAMANO = 'SEGUNDAMANO',
  SEGUNDAMANO_RETRY = 'SEGUNDAMANO_RETRY',
  STREET_ADS = 'STREET_ADS',
  STREET_ADS_RETRY = 'STREET_ADS_RETRY',
  VIVANUNCIOS = 'VIVANUNCIOS',
  VIVANUNCIOS_RETRY = 'VIVANUNCIOS_RETRY',
  WITHOUT_PUBLICATION = 'WITHOUT_PUBLICATION',
  fromApplicationSource = 'fromApplicationSource',
}

export enum IdentityDocumentType {
  CC = 'CC',
  CE = 'CE',
  CPEP = 'CPEP',
  NIT = 'NIT',
  PA = 'PA',
  TI = 'TI',
}

export type GqlImpersonateUserInputType = {
  id: Scalars['Float']['input'];
  role: ImpersonatedRole;
};

export type GqlImpersonateUserOutputType = {
  __typename?: 'ImpersonateUserOutputType';
  token: Scalars['String']['output'];
  userData?: Maybe<GqlUserOutputType>;
};

export enum ImpersonatedRole {
  CAPTURING_AGENT = 'CAPTURING_AGENT',
  LANDLORD = 'LANDLORD',
  TENANT = 'TENANT',
  VISIT_COMPANION_AGENT = 'VISIT_COMPANION_AGENT',
}

export type GqlLandlordInputType = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  identityDocumentCode: Scalars['String']['input'];
  identityDocumentType: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export enum LandlordPublishingIntention {
  RENT = 'RENT',
  SELL = 'SELL',
  SELL_OR_RENT = 'SELL_OR_RENT',
}

export type GqlLandlordType = {
  __typename?: 'LandlordType';
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  landlordId: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  status: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type GqlListAgentsAvailableCoverageRegionsOutput = {
  __typename?: 'ListAgentsAvailableCoverageRegionsOutput';
  regions: Array<GqlAgentsCoverageRegion>;
};

export type GqlListPendingAppointmentsForAgentInput = {
  geoQueryType?: InputMaybe<Scalars['String']['input']>;
  lastToken?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type GqlListPropertyListingPublicationsWithoutAgentFailure = {
  __typename?: 'ListPropertyListingPublicationsWithoutAgentFailure';
  error: GqlGqlError;
};

export type GqlListPropertyListingPublicationsWithoutAgentOutput =
  | GqlListPropertyListingPublicationsWithoutAgentFailure
  | GqlListPropertyListingPublicationsWithoutAgentSuccess;

export type GqlListPropertyListingPublicationsWithoutAgentSuccess = {
  __typename?: 'ListPropertyListingPublicationsWithoutAgentSuccess';
  publications: Array<GqlPropertyListingPublication>;
};

export type GqlLocation = {
  __typename?: 'Location';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GqlLocationType = {
  __typename?: 'LocationType';
  code: Scalars['String']['output'];
  fincaraizId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  locationType: Scalars['String']['output'];
  longitude: Scalars['Float']['output'];
  metrocuadradoId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentId: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  searchable: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GqlLoggedInUser = {
  id?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type GqlLoginResponseOutputType = {
  __typename?: 'LoginResponseOutputType';
  token?: Maybe<Scalars['String']['output']>;
  userData?: Maybe<GqlUserOutputType>;
};

export type GqlMutation = {
  __typename?: 'Mutation';
  acceptTermsAndConditions: GqlTermsAndConditionsType;
  addAuthorToPropertyListingPublication: GqlAddAuthorToPropertyListingPublicationOutput;
  addDocument: GqlCommandResponseOutputType;
  applyForRentAdvance: Scalars['Boolean']['output'];
  approveApplicationDocumentation: GqlCommandResponseOutputType;
  authenticate: GqlLoginResponseOutputType;
  authenticateAnonymousUser: GqlAnonymousUserLoginOutputType;
  batchPutPropertyListingPublicationAttribute: GqlBatchPutPropertyListingPublicationAttributeOutput;
  cancelAppointment: GqlAppointmentOutputType;
  cancelAppointmentByOps: GqlAppointmentOutputType;
  confirmAppointment: Array<GqlAppointmentOutputType>;
  confirmAppointmentByVisitCompanionAgent: Array<GqlAppointmentOutputType>;
  contact: Scalars['Boolean']['output'];
  createApplicationDocumentation: GqlCommandResponseOutputType;
  createAppointment: GqlAppointmentOutputType;
  createAppointmentDemandDeal: Scalars['Float']['output'];
  createAppointmentEstate: Scalars['Float']['output'];
  createB2bDeal: Scalars['String']['output'];
  createB2bEstate: Scalars['Int']['output'];
  createLandlord: GqlLandlordType;
  createPropertyListingPublication: GqlCreatePropertyListingPublicationOutput;
  createPropertyListingPublicationAdmin: GqlCreatePropertyListingPublicationOutput;
  createPropertyListingPublicationUploadUrl: GqlCreatePropertyListingPublicationUploadMediaUrlOutput;
  createUser: GqlUserOutputType;
  createUserWithPhone: Scalars['String']['output'];
  deleteCapturingAgent: Scalars['Boolean']['output'];
  deleteCapturingManager: Scalars['Boolean']['output'];
  deleteDocument: GqlCommandResponseOutputType;
  deletePhoto: Scalars['Boolean']['output'];
  desistSupplyDealUserIsTenant: Scalars['Int']['output'];
  editEstatePublication: Scalars['Int']['output'];
  giveEstateKeys: Scalars['Int']['output'];
  impersonateUser: GqlImpersonateUserOutputType;
  landlordConfirmAppointment: Array<GqlAppointmentOutputType>;
  landlordConfirmAppointmentByOps: Array<GqlAppointmentOutputType>;
  prequalifySupplyDealBasedOnUserIntent: Scalars['Boolean']['output'];
  propertyApplication: Scalars['Boolean']['output'];
  propertyDiscard: Scalars['Boolean']['output'];
  propertyFav: Scalars['Boolean']['output'];
  propertyUndiscard: Scalars['Boolean']['output'];
  propertyUnfav: Scalars['Boolean']['output'];
  prospectSupplyDeal: GqlCreateDealSupplyOutputType;
  publishPropertyListingPublication: GqlPublishPropertyListingPublicationOutput;
  putPropertyListingPublicationAttribute: GqlPutPropertyListingPublicationAttributeOutput;
  referral: Scalars['Boolean']['output'];
  registerBroker: GqlRegisterBrokerOutput;
  registerEstatePublication: Scalars['Int']['output'];
  rejectApplicationDocuments: GqlCommandResponseOutputType;
  removeAuthorFromPropertyListingPublication: GqlRemoveAuthorFromPropertyListingPublicationOutput;
  removePropertyListingPublicationAttribute: GqlRemovePropertyListingPublicationAttributeOutput;
  removeVisitCompanion: Scalars['Boolean']['output'];
  replaceDocument: GqlCommandResponseOutputType;
  reportWebError: GqlCommandResponseOutputType;
  republishEstate: Scalars['Boolean']['output'];
  rescheduleAppointment: GqlAppointmentOutputType;
  restrictAllEstates: Scalars['Boolean']['output'];
  restrictOneEstate: Scalars['Boolean']['output'];
  saveBenefits: Scalars['Int']['output'];
  saveCapturingAgentDocument: GqlCapturingAgentDocumentOutputType;
  saveCapturingManager: GqlCapturingManagerOutputType;
  saveSupplyDealReferral: Scalars['Int']['output'];
  saveVisitCompanion: GqlVisitCompanionOutputType;
  signUpPhone: Scalars['Boolean']['output'];
  signUpPhoneCode: GqlLoginResponseOutputType;
  specifyApplicationDocumentationType: GqlCommandResponseOutputType;
  tagResource: Scalars['Boolean']['output'];
  unpublishEstate: Scalars['Boolean']['output'];
  unpublishPropertyListingPublication: GqlUnpublishPropertyListingPublicationOutput;
  updateTenant: GqlTenantOutputType;
  updateUserInfo: GqlCommandResponseOutputType;
  uploadB2bFile: GqlOutputPhoto;
  uploadFile: GqlOutputPhoto;
  userEdit: Scalars['Boolean']['output'];
};

export type GqlMutationAcceptTermsAndConditionsArgs = {
  termsAndConditions: GqlTermsAndConditionsInputType;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlMutationAddAuthorToPropertyListingPublicationArgs = {
  author: GqlPropertyListingPublicationAuthorType;
  publicationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<GqlResourceTagInput>>>;
};

export type GqlMutationAddDocumentArgs = {
  creditStudyId: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};

export type GqlMutationApplyForRentAdvanceArgs = {
  landlord: GqlLandlordInputType;
};

export type GqlMutationApproveApplicationDocumentationArgs = {
  documentationId: Scalars['String']['input'];
};

export type GqlMutationAuthenticateArgs = {
  password: Scalars['String']['input'];
  userName: Scalars['String']['input'];
};

export type GqlMutationAuthenticateAnonymousUserArgs = {
  identificationType: Scalars['String']['input'];
  identificationValue: Scalars['String']['input'];
};

export type GqlMutationBatchPutPropertyListingPublicationAttributeArgs = {
  items: Array<GqlPropertyListingPublicationAttributeInput>;
  publicationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<GqlResourceTagInput>>>;
};

export type GqlMutationCancelAppointmentArgs = {
  appointmentId: Scalars['Int']['input'];
  cancelationReason: GqlAppointmentCancelationReasonInputType;
};

export type GqlMutationCancelAppointmentByOpsArgs = {
  appointmentId: Scalars['Int']['input'];
  cancelationReason: GqlAppointmentCancelationReasonInputType;
};

export type GqlMutationConfirmAppointmentArgs = {
  appointmentId: Scalars['Int']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  newVisitDate: Scalars['Float']['input'];
  visitCompanionId: Scalars['Int']['input'];
};

export type GqlMutationConfirmAppointmentByVisitCompanionAgentArgs = {
  appointmentId: Scalars['Int']['input'];
};

export type GqlMutationContactArgs = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type GqlMutationCreateApplicationDocumentationArgs = {
  creditStudyId: Scalars['String']['input'];
};

export type GqlMutationCreateAppointmentArgs = {
  appointment: GqlCreateAppointmentInputType;
};

export type GqlMutationCreateAppointmentDemandDealArgs = {
  input: GqlCreateAppointmentDealInputType;
};

export type GqlMutationCreateAppointmentEstateArgs = {
  input: GqlCreateAppointmentEstateType;
};

export type GqlMutationCreateB2bDealArgs = {
  b2bDeal: GqlB2bLandlordType;
};

export type GqlMutationCreateB2bEstateArgs = {
  estate: GqlEstateInput;
  userId: Scalars['Int']['input'];
};

export type GqlMutationCreateLandlordArgs = {
  newLandlord: GqlLandlordInputType;
};

export type GqlMutationCreatePropertyListingPublicationArgs = {
  items?: InputMaybe<
    Array<InputMaybe<GqlPropertyListingPublicationAttributeInput>>
  >;
  tags?: InputMaybe<Array<InputMaybe<GqlResourceTagInput>>>;
};

export type GqlMutationCreatePropertyListingPublicationAdminArgs = {
  agentUserId: Scalars['Float']['input'];
  items?: InputMaybe<
    Array<InputMaybe<GqlPropertyListingPublicationAttributeInput>>
  >;
  tags?: InputMaybe<Array<InputMaybe<GqlResourceTagInput>>>;
};

export type GqlMutationCreatePropertyListingPublicationUploadUrlArgs = {
  fileName: Scalars['String']['input'];
  publicationId: Scalars['String']['input'];
};

export type GqlMutationCreateUserArgs = {
  input: GqlCreateUserInputType;
};

export type GqlMutationCreateUserWithPhoneArgs = {
  phone: Scalars['String']['input'];
};

export type GqlMutationDeleteCapturingAgentArgs = {
  userId: Scalars['Int']['input'];
};

export type GqlMutationDeleteCapturingManagerArgs = {
  userId: Scalars['Int']['input'];
};

export type GqlMutationDeleteDocumentArgs = {
  creditStudyId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};

export type GqlMutationDeletePhotoArgs = {
  estateId: Scalars['Int']['input'];
  photoId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlMutationEditEstatePublicationArgs = {
  estate: GqlEstateInput;
  landlordUserId?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlMutationGiveEstateKeysArgs = {
  estateId: Scalars['Float']['input'];
};

export type GqlMutationImpersonateUserArgs = {
  user: GqlImpersonateUserInputType;
};

export type GqlMutationLandlordConfirmAppointmentArgs = {
  appointmentId: Scalars['Int']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMutationLandlordConfirmAppointmentByOpsArgs = {
  appointmentId: Scalars['Int']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
};

export type GqlMutationPrequalifySupplyDealBasedOnUserIntentArgs = {
  estateType: EstatePublicationType;
  landlordUserId?: InputMaybe<Scalars['Float']['input']>;
  sellOrRentIntention: LandlordPublishingIntention;
};

export type GqlMutationPropertyApplicationArgs = {
  propertyId: Scalars['Int']['input'];
};

export type GqlMutationPropertyDiscardArgs = {
  propertyId: Scalars['Int']['input'];
};

export type GqlMutationPropertyFavArgs = {
  propertyId: Scalars['Int']['input'];
};

export type GqlMutationPropertyUndiscardArgs = {
  propertyId: Scalars['Int']['input'];
};

export type GqlMutationPropertyUnfavArgs = {
  propertyId: Scalars['Int']['input'];
};

export type GqlMutationProspectSupplyDealArgs = {
  dealProperties: GqlCreateDealType;
  landlordUserId?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlMutationPublishPropertyListingPublicationArgs = {
  publicationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<GqlResourceTagInput>>>;
};

export type GqlMutationPutPropertyListingPublicationAttributeArgs = {
  attribute: GqlPropertyListingPublicationAttributeInput;
  publicationId: Scalars['String']['input'];
};

export type GqlMutationReferralArgs = {
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type GqlMutationRegisterBrokerArgs = {
  broker: GqlRegisterBrokerInputType;
};

export type GqlMutationRegisterEstatePublicationArgs = {
  estate: GqlEstateInput;
  landlordUserId?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlMutationRejectApplicationDocumentsArgs = {
  input: GqlRejectDocumentsInput;
};

export type GqlMutationRemoveAuthorFromPropertyListingPublicationArgs = {
  authorId: Scalars['Float']['input'];
  publicationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<GqlResourceTagInput>>>;
};

export type GqlMutationRemovePropertyListingPublicationAttributeArgs = {
  attributeId: Scalars['String']['input'];
  publicationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<GqlResourceTagInput>>>;
};

export type GqlMutationRemoveVisitCompanionArgs = {
  userId: Scalars['Int']['input'];
};

export type GqlMutationReplaceDocumentArgs = {
  creditStudyId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
};

export type GqlMutationReportWebErrorArgs = {
  error: GqlReportableErrorGqlType;
};

export type GqlMutationRepublishEstateArgs = {
  estateId: Scalars['Int']['input'];
};

export type GqlMutationRescheduleAppointmentArgs = {
  appointmentId: Scalars['Int']['input'];
  appointmentType: AppointmentType;
  newVisitAssistant?: InputMaybe<GqlAppointmentUserInputType>;
  newVisitDate: Scalars['Float']['input'];
};

export type GqlMutationRestrictAllEstatesArgs = {
  availavility: Array<GqlSlotAvailabilityInputType>;
};

export type GqlMutationRestrictOneEstateArgs = {
  estateAvailavility: GqlEstateVisitAvailabilityInputType;
};

export type GqlMutationSaveBenefitsArgs = {
  benefits: GqlBenefitsInputType;
};

export type GqlMutationSaveCapturingAgentDocumentArgs = {
  capturingAgentDocument: GqlCapturingAgentDocumentInputType;
};

export type GqlMutationSaveCapturingManagerArgs = {
  capturingManager: GqlCapturingManagerInputType;
};

export type GqlMutationSaveSupplyDealReferralArgs = {
  estateId: Scalars['Float']['input'];
  referralType: Scalars['String']['input'];
  referringUserId: Scalars['Float']['input'];
};

export type GqlMutationSaveVisitCompanionArgs = {
  visitCompanion: GqlVisitCompanionInputType;
};

export type GqlMutationSignUpPhoneArgs = {
  authChannel: AuthChannel;
  number: Scalars['String']['input'];
};

export type GqlMutationSignUpPhoneCodeArgs = {
  anonymousSessionId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  number: Scalars['String']['input'];
  userType: UserType;
};

export type GqlMutationSpecifyApplicationDocumentationTypeArgs = {
  declaresRent: Scalars['Boolean']['input'];
  documentation: Scalars['String']['input'];
  employmentSituation: Scalars['String']['input'];
};

export type GqlMutationTagResourceArgs = {
  arn: Scalars['String']['input'];
  tags: Array<GqlResourceTagInput>;
};

export type GqlMutationUnpublishEstateArgs = {
  estateId: Scalars['Int']['input'];
  unpublishReason: Scalars['String']['input'];
};

export type GqlMutationUnpublishPropertyListingPublicationArgs = {
  publicationId: Scalars['String']['input'];
  tags?: InputMaybe<Array<InputMaybe<GqlResourceTagInput>>>;
};

export type GqlMutationUpdateTenantArgs = {
  tenant: GqlTenantInputType;
};

export type GqlMutationUpdateUserInfoArgs = {
  user: GqlUpdateUserInputType;
};

export type GqlMutationUploadB2bFileArgs = {
  estateId: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  userId: Scalars['Int']['input'];
};

export type GqlMutationUploadFileArgs = {
  estateId: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlMutationUserEditArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identityDocumentCode?: InputMaybe<Scalars['String']['input']>;
  identityDocumentType?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type GqlOutputPhoto = {
  __typename?: 'OutputPhoto';
  id: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type GqlPendingAppointment = {
  __typename?: 'PendingAppointment';
  estateAddress: Scalars['String']['output'];
  estateId: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  type: AppointmentType;
  visitDate: Scalars['LocalDateTime']['output'];
  wasEstateReferredByAgent: Scalars['Boolean']['output'];
};

export type GqlPendingAppointmentUpdatesForAgentInput = {
  geoQueryType?: InputMaybe<Scalars['String']['input']>;
};

export type GqlPendingAppointmentUpdatesForAgentOutput = {
  __typename?: 'PendingAppointmentUpdatesForAgentOutput';
  cancelled: Array<Scalars['Float']['output']>;
  confirmed: Array<Scalars['Float']['output']>;
  incoming: Array<GqlPendingAppointment>;
};

export type GqlPendingAppointmentsPage = {
  __typename?: 'PendingAppointmentsPage';
  appointments: Array<GqlPendingAppointment>;
  nextToken?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Float']['output'];
};

export type GqlPriceType = {
  __typename?: 'PriceType';
  administrationPrice: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  price: Scalars['Float']['output'];
};

export enum PropertiesOrderByInput {
  age_ASC = 'age_ASC',
  age_DESC = 'age_DESC',
  price_ASC = 'price_ASC',
  price_DESC = 'price_DESC',
  relevant = 'relevant',
}

export type GqlPropertiesSearchResult = {
  __typename?: 'PropertiesSearchResult';
  avgPrice: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  values: Array<GqlPropertyBrief>;
};

export type GqlProperty = {
  __typename?: 'Property';
  about: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  administrationPrice: Scalars['Int']['output'];
  broker?: Maybe<Scalars['Float']['output']>;
  businessModel?: Maybe<Scalars['String']['output']>;
  characteristics?: Maybe<Array<GqlPropertyCharacteristic>>;
  currencyIso: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isExclusive: Scalars['Boolean']['output'];
  isPriceDropped: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  latitude: Scalars['Float']['output'];
  location: GqlLocation;
  locationMaps: Array<GqlPropertyLocationMap>;
  longitude: Scalars['Float']['output'];
  media?: Maybe<Array<GqlPropertyMedia>>;
  price: Scalars['Int']['output'];
  priceElectricity: Scalars['Float']['output'];
  priceGas: Scalars['Float']['output'];
  priceTIC: Scalars['Float']['output'];
  priceWater: Scalars['Float']['output'];
  propertyLegalId?: Maybe<Scalars['String']['output']>;
  propertyType: Scalars['String']['output'];
  recommendations?: Maybe<GqlEstateRecommendationType>;
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  userDiscard?: Maybe<Scalars['Boolean']['output']>;
  userFav?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPropertyBrief = {
  __typename?: 'PropertyBrief';
  administrationPrice?: Maybe<Scalars['Int']['output']>;
  area?: Maybe<Scalars['Float']['output']>;
  bathrooms: Scalars['Int']['output'];
  currencyIso: Scalars['String']['output'];
  garajes: Scalars['Int']['output'];
  hasBalcony: Scalars['Boolean']['output'];
  hasTerrace: Scalars['Boolean']['output'];
  highDemand: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  images: Array<GqlPropertyMedia>;
  isExclusive: Scalars['Boolean']['output'];
  isFurnished: Scalars['Boolean']['output'];
  isPriceDropped: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  newProperty?: Maybe<Scalars['Boolean']['output']>;
  price: Scalars['Int']['output'];
  propertyLegalId: Scalars['String']['output'];
  propertyType: Scalars['String']['output'];
  rooms: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  stratum?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  userFav: Scalars['Boolean']['output'];
};

export type GqlPropertyCharacteristic = {
  __typename?: 'PropertyCharacteristic';
  category?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  withValue?: Maybe<Scalars['Boolean']['output']>;
};

export type GqlPropertyListingPublication = {
  __typename?: 'PropertyListingPublication';
  arn: Scalars['String']['output'];
  attribute?: Maybe<GqlPropertyListingPublicationAttribute>;
  attributes: Array<Maybe<GqlPropertyListingPublicationAttribute>>;
  authors: Array<GqlPropertyListingPublicationAuthor>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  images: Array<Maybe<GqlPropertyListingPublicationMediaImageAttribute>>;
  status: GqlPropertyListingPublicationStatus;
  tag?: Maybe<GqlResourceTag>;
  tags: Array<Maybe<GqlResourceTag>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GqlPropertyListingPublicationAttributeArgs = {
  key: Scalars['String']['input'];
};

export type GqlPropertyListingPublicationTagArgs = {
  key: Scalars['String']['input'];
};

export type GqlPropertyListingPublicationAdministrationPriceAttribute = {
  __typename?: 'PropertyListingPublicationAdministrationPriceAttribute';
  currency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type GqlPropertyListingPublicationAdministrationPriceAttributeInput = {
  currency: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type GqlPropertyListingPublicationAreaM2Attribute = {
  __typename?: 'PropertyListingPublicationAreaM2Attribute';
  value: Scalars['Float']['output'];
};

export type GqlPropertyListingPublicationAreaM2AttributeInput = {
  value: Scalars['Float']['input'];
};

export type GqlPropertyListingPublicationAttribute = {
  __typename?: 'PropertyListingPublicationAttribute';
  administrationPrice?: Maybe<GqlPropertyListingPublicationAdministrationPriceAttribute>;
  areaM2?: Maybe<GqlPropertyListingPublicationAreaM2Attribute>;
  arn: Scalars['String']['output'];
  bathrooms?: Maybe<GqlPropertyListingPublicationBathroomsAttribute>;
  bedrooms?: Maybe<GqlPropertyListingPublicationBedroomsAttribute>;
  complementaryAreas?: Maybe<GqlPropertyListingPublicationComplementaryAreasAttribute>;
  constructionYear?: Maybe<GqlPropertyListingPublicationConstructionYearAttribute>;
  estateType?: Maybe<GqlPropertyListingPublicationEstateTypeAttribute>;
  estateUsage?: Maybe<GqlPropertyListingPublicationEstateUsageAttribute>;
  exteriorCharacteristics?: Maybe<GqlPropertyListingPublicationExteriorCharacteristicsAttribute>;
  floor?: Maybe<GqlPropertyListingPublicationFloorAttribute>;
  furnished?: Maybe<GqlPropertyListingPublicationFurnishedAttribute>;
  interiorFeatures?: Maybe<GqlPropertyListingPublicationInteriorFeaturesAttribute>;
  location?: Maybe<GqlPropertyListingPublicationLocationAttribute>;
  mediaImages?: Maybe<
    Array<Maybe<GqlPropertyListingPublicationMediaImageAttribute>>
  >;
  mediaImagesOrder?: Maybe<GqlPropertyListingPublicationMediaImagesOrderAttribute>;
  parkingSpaces?: Maybe<GqlPropertyListingPublicationParkingSpacesAttribute>;
  petFriendly?: Maybe<GqlPropertyListingPublicationPetFriendlyAttribute>;
  plainAddress?: Maybe<GqlPropertyListingPublicationPlainAddressAttribute>;
  rentPrice?: Maybe<GqlPropertyListingPublicationRentPriceAttribute>;
  security?: Maybe<GqlPropertyListingPublicationSecurityAttribute>;
  stratum?: Maybe<GqlPropertyListingPublicationStratumAttribute>;
  suggestedRentPrice?: Maybe<GqlPropertyListingPublicationSuggestedRentPriceAttribute>;
  tags: Array<Maybe<GqlResourceTag>>;
  type: PropertyListingPublicationAttributeInputType;
  userIntention?: Maybe<GqlPropertyListingPublicationUserIntentionAttribute>;
};

export type GqlPropertyListingPublicationAttributeInput = {
  administrationPrice?: InputMaybe<GqlPropertyListingPublicationAdministrationPriceAttributeInput>;
  areaM2?: InputMaybe<GqlPropertyListingPublicationAreaM2AttributeInput>;
  bathrooms?: InputMaybe<GqlPropertyListingPublicationBathroomsAttributeInput>;
  bedrooms?: InputMaybe<GqlPropertyListingPublicationBedroomsAttributeInput>;
  complementaryAreas?: InputMaybe<GqlPropertyListingPublicationComplementaryAreasAttributeInput>;
  constructionYear?: InputMaybe<GqlPropertyListingPublicationConstructionYearAttributeInput>;
  estateType?: InputMaybe<GqlPropertyListingPublicationEstateTypeAttributeInput>;
  estateUsage?: InputMaybe<GqlPropertyListingPublicationEstateUsageAttributeInput>;
  exteriorCharacteristics?: InputMaybe<GqlPropertyListingPublicationExteriorCharacteristicsAttributeInput>;
  floor?: InputMaybe<GqlPropertyListingPublicationFloorAttributeInput>;
  furnished?: InputMaybe<GqlPropertyListingPublicationFurnishedAttributeInput>;
  interiorFeatures?: InputMaybe<GqlPropertyListingPublicationInteriorFeaturesAttributeInput>;
  location?: InputMaybe<GqlPropertyListingPublicationLocationAttributeInput>;
  mediaImage?: InputMaybe<GqlPropertyListingPublicationMediaImageAttributeInput>;
  mediaImagesOrder?: InputMaybe<GqlPropertyListingPublicationMediaImagesOrderAttributeInput>;
  parkingSpaces?: InputMaybe<GqlPropertyListingPublicationParkingSpacesAttributeInput>;
  petFriendly?: InputMaybe<GqlPropertyListingPublicationPetFriendlyAttributeInput>;
  plainAddress?: InputMaybe<GqlPropertyListingPublicationPlainAddressAttributeInput>;
  rentPrice?: InputMaybe<GqlPropertyListingPublicationRentPriceAttributeInput>;
  security?: InputMaybe<GqlPropertyListingPublicationSecurityAttributeInput>;
  stratum?: InputMaybe<GqlPropertyListingPublicationStratumAttributeInput>;
  suggestedRentPrice?: InputMaybe<GqlPropertyListingPublicationSuggestedRentPriceAttributeInput>;
  tags?: InputMaybe<Array<InputMaybe<GqlResourceTagInput>>>;
  type: PropertyListingPublicationAttributeInputType;
  userIntention?: InputMaybe<GqlPropertyListingPublicationUserIntentionAttributeInput>;
};

export enum PropertyListingPublicationAttributeInputType {
  AMENITIES_COMPLEMENTARY_AREAS = 'AMENITIES_COMPLEMENTARY_AREAS',
  AMENITIES_EXTERIOR_CHARACTERISTICS = 'AMENITIES_EXTERIOR_CHARACTERISTICS',
  AMENITIES_INTERIOR_FEATURES = 'AMENITIES_INTERIOR_FEATURES',
  AMENITIES_SECURITY = 'AMENITIES_SECURITY',
  BASIC_INFORMATION_AREA_M2 = 'BASIC_INFORMATION_AREA_M2',
  BASIC_INFORMATION_BATHROOMS = 'BASIC_INFORMATION_BATHROOMS',
  BASIC_INFORMATION_BEDROOMS = 'BASIC_INFORMATION_BEDROOMS',
  BASIC_INFORMATION_CONSTRUCTION_YEAR = 'BASIC_INFORMATION_CONSTRUCTION_YEAR',
  BASIC_INFORMATION_FLOOR = 'BASIC_INFORMATION_FLOOR',
  BASIC_INFORMATION_FURNISHED = 'BASIC_INFORMATION_FURNISHED',
  BASIC_INFORMATION_LOCATION = 'BASIC_INFORMATION_LOCATION',
  BASIC_INFORMATION_PARKING_SPACES = 'BASIC_INFORMATION_PARKING_SPACES',
  BASIC_INFORMATION_PET_FRIENDLY = 'BASIC_INFORMATION_PET_FRIENDLY',
  BASIC_INFORMATION_PLAIN_ADDRESS = 'BASIC_INFORMATION_PLAIN_ADDRESS',
  BASIC_INFORMATION_STRATUM = 'BASIC_INFORMATION_STRATUM',
  MEDIA_IMAGE = 'MEDIA_IMAGE',
  MEDIA_IMAGES_ORDER = 'MEDIA_IMAGES_ORDER',
  PRE_QUALIFICATION_ESTATE_TYPE = 'PRE_QUALIFICATION_ESTATE_TYPE',
  PRE_QUALIFICATION_ESTATE_USAGE = 'PRE_QUALIFICATION_ESTATE_USAGE',
  PRE_QUALIFICATION_USER_INTENTION = 'PRE_QUALIFICATION_USER_INTENTION',
  PRICE_ADMINISTRATION = 'PRICE_ADMINISTRATION',
  PRICE_RENT = 'PRICE_RENT',
  PRICE_SUGGESTED_RENT = 'PRICE_SUGGESTED_RENT',
}

export type GqlPropertyListingPublicationAuthor = {
  __typename?: 'PropertyListingPublicationAuthor';
  id: Scalars['Float']['output'];
  information?: Maybe<GqlPropertyListingPublicationAuthorInformation>;
  role: Scalars['String']['output'];
};

export type GqlPropertyListingPublicationAuthorInformation = {
  __typename?: 'PropertyListingPublicationAuthorInformation';
  emailAddress?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
};

export enum PropertyListingPublicationAuthorRole {
  AGENT = 'AGENT',
  LANDLORD = 'LANDLORD',
  fromDomain = 'fromDomain',
  toDomain = 'toDomain',
}

export type GqlPropertyListingPublicationAuthorType = {
  id: Scalars['Float']['input'];
  role: PropertyListingPublicationAuthorRole;
};

export type GqlPropertyListingPublicationBathroomsAttribute = {
  __typename?: 'PropertyListingPublicationBathroomsAttribute';
  value: Scalars['Float']['output'];
};

export type GqlPropertyListingPublicationBathroomsAttributeInput = {
  value: Scalars['Float']['input'];
};

export type GqlPropertyListingPublicationBedroomsAttribute = {
  __typename?: 'PropertyListingPublicationBedroomsAttribute';
  value: Scalars['Float']['output'];
};

export type GqlPropertyListingPublicationBedroomsAttributeInput = {
  value: Scalars['Float']['input'];
};

export type GqlPropertyListingPublicationComplementaryAreasAttribute = {
  __typename?: 'PropertyListingPublicationComplementaryAreasAttribute';
  balcony: Scalars['Boolean']['output'];
  patio: Scalars['Boolean']['output'];
  storageRoom: Scalars['Boolean']['output'];
  terrace: Scalars['Boolean']['output'];
};

export type GqlPropertyListingPublicationComplementaryAreasAttributeInput = {
  balcony?: InputMaybe<Scalars['Boolean']['input']>;
  patio?: InputMaybe<Scalars['Boolean']['input']>;
  storageRoom?: InputMaybe<Scalars['Boolean']['input']>;
  terrace?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPropertyListingPublicationConstructionYearAttribute = {
  __typename?: 'PropertyListingPublicationConstructionYearAttribute';
  value: Scalars['Float']['output'];
};

export type GqlPropertyListingPublicationConstructionYearAttributeInput = {
  value: Scalars['Float']['input'];
};

export type GqlPropertyListingPublicationEstateTypeAttribute = {
  __typename?: 'PropertyListingPublicationEstateTypeAttribute';
  value: Scalars['String']['output'];
};

export type GqlPropertyListingPublicationEstateTypeAttributeInput = {
  value: Scalars['String']['input'];
};

export type GqlPropertyListingPublicationEstateUsageAttribute = {
  __typename?: 'PropertyListingPublicationEstateUsageAttribute';
  value: Scalars['String']['output'];
};

export type GqlPropertyListingPublicationEstateUsageAttributeInput = {
  value: Scalars['String']['input'];
};

export type GqlPropertyListingPublicationExteriorCharacteristicsAttribute = {
  __typename?: 'PropertyListingPublicationExteriorCharacteristicsAttribute';
  basketballCourt: Scalars['Boolean']['output'];
  bbqArea: Scalars['Boolean']['output'];
  childrenArea: Scalars['Boolean']['output'];
  communalRoom: Scalars['Boolean']['output'];
  elevator?: Maybe<Scalars['Boolean']['output']>;
  greenAreas: Scalars['Boolean']['output'];
  gym: Scalars['Boolean']['output'];
  pool: Scalars['Boolean']['output'];
  sauna: Scalars['Boolean']['output'];
  soccerField: Scalars['Boolean']['output'];
  squashCourt: Scalars['Boolean']['output'];
  tennisCourt: Scalars['Boolean']['output'];
};

export type GqlPropertyListingPublicationExteriorCharacteristicsAttributeInput =
  {
    basketballCourt?: InputMaybe<Scalars['Boolean']['input']>;
    bbqArea?: InputMaybe<Scalars['Boolean']['input']>;
    childrenArea?: InputMaybe<Scalars['Boolean']['input']>;
    communalRoom?: InputMaybe<Scalars['Boolean']['input']>;
    elevator?: InputMaybe<Scalars['Boolean']['input']>;
    greenAreas?: InputMaybe<Scalars['Boolean']['input']>;
    gym?: InputMaybe<Scalars['Boolean']['input']>;
    pool?: InputMaybe<Scalars['Boolean']['input']>;
    sauna?: InputMaybe<Scalars['Boolean']['input']>;
    soccerField?: InputMaybe<Scalars['Boolean']['input']>;
    squashCourt?: InputMaybe<Scalars['Boolean']['input']>;
    tennisCourt?: InputMaybe<Scalars['Boolean']['input']>;
  };

export type GqlPropertyListingPublicationFloorAttribute = {
  __typename?: 'PropertyListingPublicationFloorAttribute';
  value: Scalars['Float']['output'];
};

export type GqlPropertyListingPublicationFloorAttributeInput = {
  value: Scalars['Float']['input'];
};

export type GqlPropertyListingPublicationFurnishedAttribute = {
  __typename?: 'PropertyListingPublicationFurnishedAttribute';
  value: Scalars['Boolean']['output'];
};

export type GqlPropertyListingPublicationFurnishedAttributeInput = {
  value: Scalars['Boolean']['input'];
};

export type GqlPropertyListingPublicationInteriorFeaturesAttribute = {
  __typename?: 'PropertyListingPublicationInteriorFeaturesAttribute';
  fireplace: Scalars['Boolean']['output'];
  gasInstallation: Scalars['Boolean']['output'];
  heating: Scalars['Boolean']['output'];
  jacuzzi: Scalars['Boolean']['output'];
  serviceRoom: Scalars['Boolean']['output'];
  studyLibrary: Scalars['Boolean']['output'];
};

export type GqlPropertyListingPublicationInteriorFeaturesAttributeInput = {
  fireplace?: InputMaybe<Scalars['Boolean']['input']>;
  gasInstallation?: InputMaybe<Scalars['Boolean']['input']>;
  heating?: InputMaybe<Scalars['Boolean']['input']>;
  jacuzzi?: InputMaybe<Scalars['Boolean']['input']>;
  serviceRoom?: InputMaybe<Scalars['Boolean']['input']>;
  studyLibrary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPropertyListingPublicationLocationAttribute = {
  __typename?: 'PropertyListingPublicationLocationAttribute';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GqlPropertyListingPublicationLocationAttributeInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GqlPropertyListingPublicationMediaImageAttribute = {
  __typename?: 'PropertyListingPublicationMediaImageAttribute';
  arn: Scalars['String']['output'];
  attachmentId: Scalars['String']['output'];
  tag?: Maybe<GqlResourceTag>;
  tags: Array<Maybe<GqlResourceTag>>;
  url: Scalars['String']['output'];
};

export type GqlPropertyListingPublicationMediaImageAttributeTagArgs = {
  key: Scalars['String']['input'];
};

export type GqlPropertyListingPublicationMediaImageAttributeInput = {
  attachmentId: Scalars['String']['input'];
};

export type GqlPropertyListingPublicationMediaImagesOrderAttribute = {
  __typename?: 'PropertyListingPublicationMediaImagesOrderAttribute';
  arn: Scalars['String']['output'];
  order: Array<Maybe<Scalars['String']['output']>>;
};

export type GqlPropertyListingPublicationMediaImagesOrderAttributeInput = {
  order: Array<InputMaybe<Scalars['String']['input']>>;
};

export type GqlPropertyListingPublicationParkingSpacesAttribute = {
  __typename?: 'PropertyListingPublicationParkingSpacesAttribute';
  value: Scalars['Float']['output'];
};

export type GqlPropertyListingPublicationParkingSpacesAttributeInput = {
  value: Scalars['Float']['input'];
};

export type GqlPropertyListingPublicationPetFriendlyAttribute = {
  __typename?: 'PropertyListingPublicationPetFriendlyAttribute';
  value: Scalars['Boolean']['output'];
};

export type GqlPropertyListingPublicationPetFriendlyAttributeInput = {
  value: Scalars['Boolean']['input'];
};

export type GqlPropertyListingPublicationPlainAddressAttribute = {
  __typename?: 'PropertyListingPublicationPlainAddressAttribute';
  details: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlPropertyListingPublicationPlainAddressAttributeInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type GqlPropertyListingPublicationRentPriceAttribute = {
  __typename?: 'PropertyListingPublicationRentPriceAttribute';
  currency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type GqlPropertyListingPublicationRentPriceAttributeInput = {
  currency: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type GqlPropertyListingPublicationSecurityAttribute = {
  __typename?: 'PropertyListingPublicationSecurityAttribute';
  alarm: Scalars['Boolean']['output'];
  cctv: Scalars['Boolean']['output'];
  securityDoor: Scalars['Boolean']['output'];
};

export type GqlPropertyListingPublicationSecurityAttributeInput = {
  alarm?: InputMaybe<Scalars['Boolean']['input']>;
  cctv?: InputMaybe<Scalars['Boolean']['input']>;
  securityDoor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlPropertyListingPublicationStatus = {
  __typename?: 'PropertyListingPublicationStatus';
  since: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
};

export type GqlPropertyListingPublicationStratumAttribute = {
  __typename?: 'PropertyListingPublicationStratumAttribute';
  value: Scalars['Float']['output'];
};

export type GqlPropertyListingPublicationStratumAttributeInput = {
  value: Scalars['Float']['input'];
};

export type GqlPropertyListingPublicationSuggestedRentPriceAttribute = {
  __typename?: 'PropertyListingPublicationSuggestedRentPriceAttribute';
  currency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type GqlPropertyListingPublicationSuggestedRentPriceAttributeInput = {
  currency: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type GqlPropertyListingPublicationUserIntentionAttribute = {
  __typename?: 'PropertyListingPublicationUserIntentionAttribute';
  value: Scalars['String']['output'];
};

export type GqlPropertyListingPublicationUserIntentionAttributeInput = {
  value: Scalars['String']['input'];
};

/** Property location static map url */
export type GqlPropertyLocationMap = {
  __typename?: 'PropertyLocationMap';
  size: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GqlPropertyMedia = {
  __typename?: 'PropertyMedia';
  id: Scalars['Int']['output'];
  main: Scalars['Boolean']['output'];
  uri: Scalars['String']['output'];
};

export enum PublicationCoverage {
  COVERED = 'COVERED',
  NOT_COVERED = 'NOT_COVERED',
  UNKNOWN = 'UNKNOWN',
}

export type GqlPublishPropertyListingPublicationFailure = {
  __typename?: 'PublishPropertyListingPublicationFailure';
  error: GqlGqlError;
};

export type GqlPublishPropertyListingPublicationOutput =
  | GqlPublishPropertyListingPublicationFailure
  | GqlPublishPropertyListingPublicationSuccess;

export type GqlPublishPropertyListingPublicationSuccess = {
  __typename?: 'PublishPropertyListingPublicationSuccess';
  publication: GqlPropertyListingPublication;
};

export type GqlPutPropertyListingPublicationAttributeFailure = {
  __typename?: 'PutPropertyListingPublicationAttributeFailure';
  error: GqlGqlError;
};

export type GqlPutPropertyListingPublicationAttributeOutput =
  | GqlPutPropertyListingPublicationAttributeFailure
  | GqlPutPropertyListingPublicationAttributeSuccess;

export type GqlPutPropertyListingPublicationAttributeSuccess = {
  __typename?: 'PutPropertyListingPublicationAttributeSuccess';
  publication: GqlPropertyListingPublication;
};

export type GqlQuery = {
  __typename?: 'Query';
  buildSignedUrlForFileUploading: Scalars['String']['output'];
  countVisitedAppointmentsByEstateForLastMonth?: Maybe<
    Scalars['Float']['output']
  >;
  estateVisitAvailability: GqlEstateVisitAvailabilityOutputType;
  exposedDocumentation?: Maybe<GqlExposedDocumentationOutputType>;
  exposedEstate?: Maybe<GqlExposedEstateOutputType>;
  filters: GqlFilters;
  getAgentBySlug: GqlGetAgentBySlugOutputType;
  getAmountOfEffectiveAppointmentsOnDifferentEstatesForChainScheduling: Scalars['Int']['output'];
  getAmountOfOpenAppointmentsOnDifferentEstates: Scalars['Int']['output'];
  getAppointmentsAvailability: Array<GqlAppointmentAvalilabilityOutputType>;
  getAppointmentsByEstate: Array<GqlAppointmentOutputType>;
  getAppointmentsByEstateForLastMoth: Array<GqlAppointmentOutputType>;
  getAppointmentsByLandlord: Array<GqlAppointmentOutputType>;
  getAppointmentsByTenant: Array<GqlAppointmentOutputType>;
  getAppointmentsByVisitCompanionAgent: Array<GqlAppointmentOutputType>;
  getAuthenticatedUser?: Maybe<GqlUserOutputType>;
  getCapturingManagers: Array<GqlCapturingManagerOutputType>;
  getCompletedAppointmentsByTenant: Array<GqlCompletedAppointmentOutputType>;
  getCoordinatesFromAddress: GqlCoordinatesType;
  getEstate: GqlProperty;
  getEstateReferral: GqlUserOutputType;
  getGeneralEstatePublicationQualityIndex: GqlGeneralEstatePublicationQualityOutputType;
  getPropertyListingPublication: GqlGetPropertyListingPublicationOutput;
  getRecommendationsForLatestScheduledEstate: Array<GqlPropertyBrief>;
  getSearchableEstateLocation: Array<GqlSearchableEstateLocationOutputType>;
  getTenantByPhone?: Maybe<GqlTenantOutputType>;
  getTenantForAuthenticatedUser?: Maybe<GqlTenantOutputType>;
  getUserEstates: Array<GqlFullEstateType>;
  getVisitCompanions: Array<GqlVisitCompanionOutputType>;
  getVisitFeedbacksByEstate: Array<GqlVisitFeedbackOutputType>;
  internalDocumentation?: Maybe<GqlDocumentationOutputType>;
  listAgentsAvailableCoverageRegions: GqlListAgentsAvailableCoverageRegionsOutput;
  listPendingAppointmentUpdatesForAgent: GqlPendingAppointmentUpdatesForAgentOutput;
  listPendingAppointmentsForAgent: GqlPendingAppointmentsPage;
  listPropertyListingPublicationsWithoutAgent: GqlListPropertyListingPublicationsWithoutAgentOutput;
  listUserPropertyListingPublications: GqlUserPropertyListingPublicationsOutput;
  myReferredEstate?: Maybe<GqlEstateOutputTypeGql>;
  myReferredEstates: Array<GqlEstateOutputTypeGql>;
  properties: GqlPropertiesSearchResult;
  propertiesDiscards: GqlDiscardsResponse;
  property: GqlProperty;
  propetiesFavs: GqlFavsResponse;
  publicationCoverage: PublicationCoverage;
  userInformation?: Maybe<GqlUserOutputType>;
  userInformationByDocument?: Maybe<GqlUserOutputType>;
  userInformationByPhone?: Maybe<GqlUserOutputType>;
  userRecommendations?: Maybe<GqlUserRecommendationOutputType>;
};

export type GqlQueryBuildSignedUrlForFileUploadingArgs = {
  bucket: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type GqlQueryCountVisitedAppointmentsByEstateForLastMonthArgs = {
  estateId: Scalars['Int']['input'];
};

export type GqlQueryEstateVisitAvailabilityArgs = {
  date?: InputMaybe<Scalars['Float']['input']>;
  estateId: Scalars['Int']['input'];
};

export type GqlQueryExposedDocumentationArgs = {
  creditStudyId: Scalars['String']['input'];
};

export type GqlQueryExposedEstateArgs = {
  estateId: Scalars['Float']['input'];
};

export type GqlQueryFiltersArgs = {
  filters: GqlEstatesSearchFilterType;
};

export type GqlQueryGetAgentBySlugArgs = {
  slug: Scalars['String']['input'];
};

export type GqlQueryGetAppointmentsAvailabilityArgs = {
  estateId: Scalars['Int']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlQueryGetAppointmentsByEstateArgs = {
  estateLegalId: Scalars['String']['input'];
};

export type GqlQueryGetAppointmentsByEstateForLastMothArgs = {
  estateLegalId: Scalars['String']['input'];
};

export type GqlQueryGetAppointmentsByTenantArgs = {
  TenantAppointmentsFilter: GqlTenantAppointmentsFilterInputType;
};

export type GqlQueryGetCompletedAppointmentsByTenantArgs = {
  page?: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlQueryGetCoordinatesFromAddressArgs = {
  address: Scalars['String']['input'];
};

export type GqlQueryGetEstateArgs = {
  estateId: Scalars['Float']['input'];
};

export type GqlQueryGetEstateReferralArgs = {
  estateId: Scalars['Float']['input'];
};

export type GqlQueryGetPropertyListingPublicationArgs = {
  id: Scalars['String']['input'];
};

export type GqlQueryGetSearchableEstateLocationArgs = {
  typedLocationName: Scalars['String']['input'];
};

export type GqlQueryGetTenantByPhoneArgs = {
  phoneNumber: Scalars['String']['input'];
};

export type GqlQueryGetVisitFeedbacksByEstateArgs = {
  estateLegalId: Scalars['String']['input'];
};

export type GqlQueryInternalDocumentationArgs = {
  creditStudyId: Scalars['String']['input'];
  userId: Scalars['Float']['input'];
};

export type GqlQueryListPendingAppointmentUpdatesForAgentArgs = {
  input: GqlPendingAppointmentUpdatesForAgentInput;
};

export type GqlQueryListPendingAppointmentsForAgentArgs = {
  input: GqlListPendingAppointmentsForAgentInput;
};

export type GqlQueryMyReferredEstateArgs = {
  estateId: Scalars['Float']['input'];
};

export type GqlQueryPropertiesArgs = {
  filters: GqlEstatesSearchFilterType;
  from?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PropertiesOrderByInput>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlQueryPropertiesDiscardsArgs = {
  params?: InputMaybe<Scalars['String']['input']>;
};

export type GqlQueryPropertyArgs = {
  propertyId: Scalars['String']['input'];
};

export type GqlQueryPropetiesFavsArgs = {
  params?: InputMaybe<Scalars['String']['input']>;
};

export type GqlQueryPublicationCoverageArgs = {
  estateId: Scalars['Float']['input'];
};

export type GqlQueryUserInformationArgs = {
  userId: Scalars['Float']['input'];
};

export type GqlQueryUserInformationByDocumentArgs = {
  documentCode: Scalars['String']['input'];
  documentType: IdentityDocumentType;
};

export type GqlQueryUserInformationByPhoneArgs = {
  phone: Scalars['String']['input'];
};

export type GqlRankingType = {
  __typename?: 'RankingType';
  calculatedRank: Scalars['Float']['output'];
  obtainedScoring: Scalars['Float']['output'];
};

export type GqlRecommendationEstateOutputType = {
  __typename?: 'RecommendationEstateOutputType';
  admonPrice: Scalars['Float']['output'];
  area: Scalars['Float']['output'];
  bathrooms: Scalars['Float']['output'];
  bedrooms: Scalars['Float']['output'];
  estateId: Scalars['Float']['output'];
  estateLegalId: Scalars['String']['output'];
  imagesUrl: Array<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  ranking: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

export type GqlRecommendationsByCategoryOutputType = {
  __typename?: 'RecommendationsByCategoryOutputType';
  category: GqlCategoryOutputType;
  estates: Array<GqlRecommendationEstateOutputType>;
};

export type GqlRecommendedEstateType = {
  __typename?: 'RecommendedEstateType';
  administrationPrice: Scalars['Int']['output'];
  area: Scalars['Float']['output'];
  bathrooms: Scalars['Int']['output'];
  currencyISO: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isAnewProperty: Scalars['Boolean']['output'];
  isFurnished: Scalars['Boolean']['output'];
  isInHighDemand: Scalars['Boolean']['output'];
  isPriceDropped: Scalars['Boolean']['output'];
  legalId: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  propertyType: Scalars['String']['output'];
  ranking: GqlRankingType;
  rooms: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GqlRegisterBrokerFailureType = {
  __typename?: 'RegisterBrokerFailureType';
  error: GqlGqlError;
};

export type GqlRegisterBrokerInputType = {
  address?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  detailAddress?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  hasListings: Scalars['Boolean']['input'];
  job: BrokerBusinessKind;
  lastName: Scalars['String']['input'];
  ownerManager?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

export type GqlRegisterBrokerOutput =
  | GqlRegisterBrokerFailureType
  | GqlRegisterBrokerSuccessType;

export type GqlRegisterBrokerSuccessType = {
  __typename?: 'RegisterBrokerSuccessType';
  userId: Scalars['Int']['output'];
};

export type GqlRejectDocumentsInput = {
  documentationId: Scalars['String']['input'];
  documentsToReject: Array<Scalars['String']['input']>;
  suggestions: Scalars['String']['input'];
};

export type GqlRemoveAuthorFromPropertyListingPublicationFailure = {
  __typename?: 'RemoveAuthorFromPropertyListingPublicationFailure';
  error: GqlGqlError;
};

export type GqlRemoveAuthorFromPropertyListingPublicationOutput =
  | GqlRemoveAuthorFromPropertyListingPublicationFailure
  | GqlRemoveAuthorFromPropertyListingPublicationSuccess;

export type GqlRemoveAuthorFromPropertyListingPublicationSuccess = {
  __typename?: 'RemoveAuthorFromPropertyListingPublicationSuccess';
  publication: GqlPropertyListingPublication;
};

export type GqlRemovePropertyListingPublicationAttributeFailure = {
  __typename?: 'RemovePropertyListingPublicationAttributeFailure';
  error: GqlGqlError;
};

export type GqlRemovePropertyListingPublicationAttributeOutput =
  | GqlRemovePropertyListingPublicationAttributeFailure
  | GqlRemovePropertyListingPublicationAttributeSuccess;

export type GqlRemovePropertyListingPublicationAttributeSuccess = {
  __typename?: 'RemovePropertyListingPublicationAttributeSuccess';
  publication: GqlPropertyListingPublication;
};

export type GqlReportableErrorGqlType = {
  cause: Scalars['String']['input'];
  loggedInUser?: InputMaybe<GqlLoggedInUser>;
};

export type GqlResourceTag = {
  __typename?: 'ResourceTag';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GqlResourceTagInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type GqlSearchFilterAggregation = {
  __typename?: 'SearchFilterAggregation';
  aggregation: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type GqlSearchableEstateLocationOutputType = {
  __typename?: 'SearchableEstateLocationOutputType';
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  locationNameLong: Scalars['String']['output'];
  locationOrder: Scalars['Int']['output'];
  locationSlug: Scalars['String']['output'];
  locationType: EstateLocationType;
  parents: Array<GqlEstateLocationParentsOutputType>;
};

export type GqlSearchableLocation = {
  __typename?: 'SearchableLocation';
  code: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  locationType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GqlSlotAvailabilityInputType = {
  date: Scalars['Float']['input'];
  enabled: Scalars['Boolean']['input'];
  timesToRepeat?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlSlotAvailabilityOutputType = {
  __typename?: 'SlotAvailabilityOutputType';
  confirmed: Scalars['Boolean']['output'];
  date: Scalars['Float']['output'];
  enabled: Scalars['Boolean']['output'];
};

export type GqlTenantAppointmentsFilterInputType = {
  fromVisitDate?: InputMaybe<Scalars['Float']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['Float']['input']>;
};

export type GqlTenantInputType = {
  email: Scalars['String']['input'];
  estimatedMoveDate: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  identityDocumentCode: Scalars['String']['input'];
  identityDocumentType: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  status: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type GqlTenantOutputType = {
  __typename?: 'TenantOutputType';
  email?: Maybe<Scalars['String']['output']>;
  estimatedMoveDate?: Maybe<EstimatedMoveDate>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identityDocumentCode?: Maybe<Scalars['String']['output']>;
  identityDocumentType?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  status: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type GqlTermsAndConditionsInputType = {
  estateId: Scalars['Int']['input'];
  isExclusive: Scalars['Boolean']['input'];
  type: TermsAndConditionsTypeEnum;
};

export type GqlTermsAndConditionsType = {
  __typename?: 'TermsAndConditionsType';
  estateId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isExclusive: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export enum TermsAndConditionsTypeEnum {
  BLUE = 'BLUE',
  BROKERAGE = 'BROKERAGE',
  PLUS = 'PLUS',
  WARRANTY = 'WARRANTY',
  WARRANTY_SINGLE_PAYMENT = 'WARRANTY_SINGLE_PAYMENT',
}

export type GqlUnpublishPropertyListingPublicationFailure = {
  __typename?: 'UnpublishPropertyListingPublicationFailure';
  error: GqlGqlError;
};

export type GqlUnpublishPropertyListingPublicationOutput =
  | GqlUnpublishPropertyListingPublicationFailure
  | GqlUnpublishPropertyListingPublicationSuccess;

export type GqlUnpublishPropertyListingPublicationSuccess = {
  __typename?: 'UnpublishPropertyListingPublicationSuccess';
  publication: GqlPropertyListingPublication;
};

export type GqlUpdateUserInputType = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  identityDocumentCode: Scalars['String']['input'];
  identityDocumentType: IdentityDocumentType;
  lastName: Scalars['String']['input'];
};

export type GqlUserImpersonator = {
  __typename?: 'UserImpersonator';
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type GqlUserOutputType = {
  __typename?: 'UserOutputType';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  identityDocumentCode?: Maybe<Scalars['String']['output']>;
  identityDocumentType?: Maybe<Scalars['String']['output']>;
  impersonatedBy?: Maybe<GqlUserImpersonator>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GqlUserPropertyDiscard = {
  __typename?: 'UserPropertyDiscard';
  property: GqlProperty;
};

export type GqlUserPropertyFav = {
  __typename?: 'UserPropertyFav';
  property: GqlProperty;
};

export type GqlUserPropertyListingPublicationsOutput = {
  __typename?: 'UserPropertyListingPublicationsOutput';
  publications: Array<GqlPropertyListingPublication>;
};

export type GqlUserRecommendationOutputType = {
  __typename?: 'UserRecommendationOutputType';
  recommendationsByCategory: Array<GqlRecommendationsByCategoryOutputType>;
};

export enum UserType {
  ADMIN = 'ADMIN',
  ANONYMOUS = 'ANONYMOUS',
  CAPTURING_AGENT = 'CAPTURING_AGENT',
  LANDLORD = 'LANDLORD',
  MKT = 'MKT',
  OPS = 'OPS',
  RENTAL_AGREEMENT_MEMBER = 'RENTAL_AGREEMENT_MEMBER',
  TENANT = 'TENANT',
  VISIT_COMPANION_AGENT = 'VISIT_COMPANION_AGENT',
}

export type GqlVisitCompanionInputType = {
  coverage: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  identityDocumentCode: Scalars['String']['input'];
  identityDocumentType: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type GqlVisitCompanionOutputType = {
  __typename?: 'VisitCompanionOutputType';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  identityDocumentCode?: Maybe<Scalars['String']['output']>;
  identityDocumentType?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phoneCode: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type GqlVisitFeedbackOutputType = {
  __typename?: 'VisitFeedbackOutputType';
  cleanliness: Scalars['Float']['output'];
  customerOpinion: Scalars['String']['output'];
  stateSpace: Scalars['Float']['output'];
  tenantFullName: Scalars['String']['output'];
  visitDate: Scalars['Float']['output'];
};

export type GqlGetAgentBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GqlGetAgentBySlugQuery = {
  __typename?: 'Query';
  getAgentBySlug:
    | {
        __typename?: 'GetAgentBySlugFailure';
        error: {
          __typename: 'GqlError';
          code: string;
          message: string;
          metadata: Array<{
            __typename?: 'GqlErrorMetadataItem';
            key: string;
            value: string;
          }>;
        };
      }
    | {
        __typename?: 'GetAgentBySlugSuccess';
        agent: {
          __typename?: 'Agent';
          id: number;
          userId: number;
          applicationUrl: string;
          information: {
            __typename?: 'AgentInformation';
            firstName: string;
            lastName: string;
            slug: string;
          };
        };
      };
};

export type GqlGqlErrorFragment = {
  __typename: 'GqlError';
  code: string;
  message: string;
  metadata: Array<{
    __typename?: 'GqlErrorMetadataItem';
    key: string;
    value: string;
  }>;
};

export type GqlCreatePropertyListingPublicationUploadUrlMutationVariables =
  Exact<{
    publicationId: Scalars['String']['input'];
    fileName: Scalars['String']['input'];
  }>;

export type GqlCreatePropertyListingPublicationUploadUrlMutation = {
  __typename?: 'Mutation';
  createPropertyListingPublicationUploadUrl:
    | {
        __typename: 'CreatePropertyListingPublicationUploadMediaUrlFailure';
        error: {
          __typename?: 'GqlError';
          code: string;
          message: string;
          metadata: Array<{
            __typename?: 'GqlErrorMetadataItem';
            key: string;
            value: string;
          }>;
        };
      }
    | {
        __typename: 'CreatePropertyListingPublicationUploadMediaUrlSuccess';
        attachmentId: string;
        uploadPath: string;
        uploadUrl: string;
      };
};

export type GqlCreatePropertyListingPublicationMutationVariables = Exact<{
  tags?: InputMaybe<
    Array<InputMaybe<GqlResourceTagInput>> | InputMaybe<GqlResourceTagInput>
  >;
}>;

export type GqlCreatePropertyListingPublicationMutation = {
  __typename?: 'Mutation';
  createPropertyListingPublication:
    | {
        __typename: 'CreatePropertyListingPublicationFailure';
        error: {
          __typename?: 'GqlError';
          code: string;
          message: string;
          metadata: Array<{
            __typename?: 'GqlErrorMetadataItem';
            key: string;
            value: string;
          }>;
        };
      }
    | {
        __typename: 'CreatePropertyListingPublicationSuccess';
        publication: { __typename?: 'PropertyListingPublication'; id: string };
      };
};

export type GqlGetPublicationBasicInformationQueryVariables = Exact<{
  publicationId: Scalars['String']['input'];
}>;

export type GqlGetPublicationBasicInformationQuery = {
  __typename?: 'Query';
  getPropertyListingPublication:
    | {
        __typename: 'GetPropertyListingPublicationFailure';
        error: {
          __typename?: 'GqlError';
          code: string;
          message: string;
          metadata: Array<{
            __typename?: 'GqlErrorMetadataItem';
            key: string;
            value: string;
          }>;
        };
      }
    | {
        __typename: 'GetPropertyListingPublicationSuccess';
        publication: {
          __typename?: 'PropertyListingPublication';
          id: string;
          furnished?: {
            __typename?: 'PropertyListingPublicationAttribute';
            furnished?: {
              __typename?: 'PropertyListingPublicationFurnishedAttribute';
              value: boolean;
            } | null;
          } | null;
          constructionYear?: {
            __typename?: 'PropertyListingPublicationAttribute';
            constructionYear?: {
              __typename?: 'PropertyListingPublicationConstructionYearAttribute';
              value: number;
            } | null;
          } | null;
          bathrooms?: {
            __typename?: 'PropertyListingPublicationAttribute';
            bathrooms?: {
              __typename?: 'PropertyListingPublicationBathroomsAttribute';
              value: number;
            } | null;
          } | null;
          bedrooms?: {
            __typename?: 'PropertyListingPublicationAttribute';
            bedrooms?: {
              __typename?: 'PropertyListingPublicationBedroomsAttribute';
              value: number;
            } | null;
          } | null;
          areaM2?: {
            __typename?: 'PropertyListingPublicationAttribute';
            areaM2?: {
              __typename?: 'PropertyListingPublicationAreaM2Attribute';
              value: number;
            } | null;
          } | null;
          parkingSpaces?: {
            __typename?: 'PropertyListingPublicationAttribute';
            parkingSpaces?: {
              __typename?: 'PropertyListingPublicationParkingSpacesAttribute';
              value: number;
            } | null;
          } | null;
          floor?: {
            __typename?: 'PropertyListingPublicationAttribute';
            floor?: {
              __typename?: 'PropertyListingPublicationFloorAttribute';
              value: number;
            } | null;
          } | null;
          stratum?: {
            __typename?: 'PropertyListingPublicationAttribute';
            stratum?: {
              __typename?: 'PropertyListingPublicationStratumAttribute';
              value: number;
            } | null;
          } | null;
          petFriendly?: {
            __typename?: 'PropertyListingPublicationAttribute';
            petFriendly?: {
              __typename?: 'PropertyListingPublicationPetFriendlyAttribute';
              value: boolean;
            } | null;
          } | null;
        };
      };
};

export type GqlGetPublicationFeaturesQueryVariables = Exact<{
  publicationId: Scalars['String']['input'];
}>;

export type GqlGetPublicationFeaturesQuery = {
  __typename?: 'Query';
  getPropertyListingPublication:
    | {
        __typename: 'GetPropertyListingPublicationFailure';
        error: {
          __typename?: 'GqlError';
          code: string;
          message: string;
          metadata: Array<{
            __typename?: 'GqlErrorMetadataItem';
            key: string;
            value: string;
          }>;
        };
      }
    | {
        __typename: 'GetPropertyListingPublicationSuccess';
        publication: {
          __typename?: 'PropertyListingPublication';
          id: string;
          complementaryAreas?: {
            __typename?: 'PropertyListingPublicationAttribute';
            complementaryAreas?: {
              __typename?: 'PropertyListingPublicationComplementaryAreasAttribute';
              balcony: boolean;
              storageRoom: boolean;
              patio: boolean;
              terrace: boolean;
            } | null;
          } | null;
          security?: {
            __typename?: 'PropertyListingPublicationAttribute';
            security?: {
              __typename?: 'PropertyListingPublicationSecurityAttribute';
              alarm: boolean;
              cctv: boolean;
              securityDoor: boolean;
            } | null;
          } | null;
          interiorFeatures?: {
            __typename?: 'PropertyListingPublicationAttribute';
            interiorFeatures?: {
              __typename?: 'PropertyListingPublicationInteriorFeaturesAttribute';
              heating: boolean;
              fireplace: boolean;
              serviceRoom: boolean;
              studyLibrary: boolean;
              gasInstallation: boolean;
              jacuzzi: boolean;
            } | null;
          } | null;
          exteriorCharacteristics?: {
            __typename?: 'PropertyListingPublicationAttribute';
            exteriorCharacteristics?: {
              __typename?: 'PropertyListingPublicationExteriorCharacteristicsAttribute';
              elevator?: boolean | null;
              basketballCourt: boolean;
              soccerField: boolean;
              squashCourt: boolean;
              tennisCourt: boolean;
              gym: boolean;
              pool: boolean;
              communalRoom: boolean;
              sauna: boolean;
              bbqArea: boolean;
              childrenArea: boolean;
              greenAreas: boolean;
            } | null;
          } | null;
        };
      };
};

export type GqlGetPublicationLocationQueryVariables = Exact<{
  publicationId: Scalars['String']['input'];
}>;

export type GqlGetPublicationLocationQuery = {
  __typename?: 'Query';
  getPropertyListingPublication:
    | {
        __typename: 'GetPropertyListingPublicationFailure';
        error: {
          __typename?: 'GqlError';
          code: string;
          message: string;
          metadata: Array<{
            __typename?: 'GqlErrorMetadataItem';
            key: string;
            value: string;
          }>;
        };
      }
    | {
        __typename: 'GetPropertyListingPublicationSuccess';
        publication: {
          __typename?: 'PropertyListingPublication';
          id: string;
          plainAddress?: {
            __typename?: 'PropertyListingPublicationAttribute';
            plainAddress?: {
              __typename?: 'PropertyListingPublicationPlainAddressAttribute';
              value: string;
              details: string;
            } | null;
          } | null;
          location?: {
            __typename?: 'PropertyListingPublicationAttribute';
            location?: {
              __typename?: 'PropertyListingPublicationLocationAttribute';
              latitude: number;
              longitude: number;
            } | null;
          } | null;
        };
      };
};

export type GqlGetPublicationImagesQueryVariables = Exact<{
  publicationId: Scalars['String']['input'];
}>;

export type GqlGetPublicationImagesQuery = {
  __typename?: 'Query';
  getPropertyListingPublication:
    | {
        __typename: 'GetPropertyListingPublicationFailure';
        error: {
          __typename?: 'GqlError';
          code: string;
          message: string;
          metadata: Array<{
            __typename?: 'GqlErrorMetadataItem';
            key: string;
            value: string;
          }>;
        };
      }
    | {
        __typename: 'GetPropertyListingPublicationSuccess';
        publication: {
          __typename?: 'PropertyListingPublication';
          id: string;
          images: Array<{
            __typename?: 'PropertyListingPublicationMediaImageAttribute';
            attachmentId: string;
            url: string;
            fileName?: { __typename?: 'ResourceTag'; value: string } | null;
          } | null>;
          images_order?: {
            __typename?: 'PropertyListingPublicationAttribute';
            mediaImagesOrder?: {
              __typename?: 'PropertyListingPublicationMediaImagesOrderAttribute';
              order: Array<string | null>;
            } | null;
          } | null;
        };
      };
};

export type GqlGetPublicationPreQualificationQueryVariables = Exact<{
  publicationId: Scalars['String']['input'];
}>;

export type GqlGetPublicationPreQualificationQuery = {
  __typename?: 'Query';
  getPropertyListingPublication:
    | {
        __typename: 'GetPropertyListingPublicationFailure';
        error: {
          __typename?: 'GqlError';
          code: string;
          message: string;
          metadata: Array<{
            __typename?: 'GqlErrorMetadataItem';
            key: string;
            value: string;
          }>;
        };
      }
    | {
        __typename: 'GetPropertyListingPublicationSuccess';
        publication: {
          __typename?: 'PropertyListingPublication';
          id: string;
          estateType?: {
            __typename?: 'PropertyListingPublicationAttribute';
            estateType?: {
              __typename?: 'PropertyListingPublicationEstateTypeAttribute';
              value: string;
            } | null;
          } | null;
          estateUsage?: {
            __typename?: 'PropertyListingPublicationAttribute';
            estateUsage?: {
              __typename?: 'PropertyListingPublicationEstateUsageAttribute';
              value: string;
            } | null;
          } | null;
          user_intention?: {
            __typename?: 'PropertyListingPublicationAttribute';
            userIntention?: {
              __typename?: 'PropertyListingPublicationUserIntentionAttribute';
              value: string;
            } | null;
          } | null;
        };
      };
};

export type GqlGetPublicationPricesQueryVariables = Exact<{
  publicationId: Scalars['String']['input'];
}>;

export type GqlGetPublicationPricesQuery = {
  __typename?: 'Query';
  getPropertyListingPublication:
    | {
        __typename: 'GetPropertyListingPublicationFailure';
        error: {
          __typename?: 'GqlError';
          code: string;
          message: string;
          metadata: Array<{
            __typename?: 'GqlErrorMetadataItem';
            key: string;
            value: string;
          }>;
        };
      }
    | {
        __typename: 'GetPropertyListingPublicationSuccess';
        publication: {
          __typename?: 'PropertyListingPublication';
          id: string;
          rent?: {
            __typename?: 'PropertyListingPublicationAttribute';
            rentPrice?: {
              __typename?: 'PropertyListingPublicationRentPriceAttribute';
              value: number;
            } | null;
          } | null;
          administration?: {
            __typename?: 'PropertyListingPublicationAttribute';
            administrationPrice?: {
              __typename?: 'PropertyListingPublicationAdministrationPriceAttribute';
              value: number;
            } | null;
          } | null;
        };
      };
};

export type GqlListUserPublicationsQueryVariables = Exact<{
  nameKey: Scalars['String']['input'];
  descriptionKey: Scalars['String']['input'];
  lastKnownStepKey: Scalars['String']['input'];
}>;

export type GqlListUserPublicationsQuery = {
  __typename?: 'Query';
  listUserPropertyListingPublications: {
    __typename?: 'UserPropertyListingPublicationsOutput';
    publications: Array<{
      __typename?: 'PropertyListingPublication';
      id: string;
      createdAt: any;
      updatedAt: any;
      status: {
        __typename?: 'PropertyListingPublicationStatus';
        type: string;
        since: any;
      };
      authors: Array<{
        __typename?: 'PropertyListingPublicationAuthor';
        id: number;
        role: string;
      }>;
      name?: { __typename?: 'ResourceTag'; value: string } | null;
      description?: { __typename?: 'ResourceTag'; value: string } | null;
      lastKnownStep?: { __typename?: 'ResourceTag'; value: string } | null;
      plainAddress?: {
        __typename?: 'PropertyListingPublicationAttribute';
        plainAddress?: {
          __typename?: 'PropertyListingPublicationPlainAddressAttribute';
          value: string;
          details: string;
        } | null;
      } | null;
    }>;
  };
};

export type GqlRemovePropertyListingPublicationAttributeMutationVariables =
  Exact<{
    publicationId: Scalars['String']['input'];
    attributeId: Scalars['String']['input'];
  }>;

export type GqlRemovePropertyListingPublicationAttributeMutation = {
  __typename?: 'Mutation';
  removePropertyListingPublicationAttribute:
    | {
        __typename: 'RemovePropertyListingPublicationAttributeFailure';
        error: {
          __typename?: 'GqlError';
          code: string;
          message: string;
          metadata: Array<{
            __typename?: 'GqlErrorMetadataItem';
            key: string;
            value: string;
          }>;
        };
      }
    | {
        __typename: 'RemovePropertyListingPublicationAttributeSuccess';
        publication: { __typename?: 'PropertyListingPublication'; id: string };
      };
};

export type GqlTagResourceMutationVariables = Exact<{
  arn: Scalars['String']['input'];
  tags: Array<GqlResourceTagInput> | GqlResourceTagInput;
}>;

export type GqlTagResourceMutation = {
  __typename?: 'Mutation';
  tagResource: boolean;
};

export type GqlUpdatePublicationAttributesMutationVariables = Exact<{
  items:
    | Array<GqlPropertyListingPublicationAttributeInput>
    | GqlPropertyListingPublicationAttributeInput;
  publicationId: Scalars['String']['input'];
}>;

export type GqlUpdatePublicationAttributesMutation = {
  __typename?: 'Mutation';
  batchPutPropertyListingPublicationAttribute:
    | { __typename: 'BatchPutPropertyListingPublicationAttributesFailure' }
    | {
        __typename: 'BatchPutPropertyListingPublicationAttributesSuccess';
      };
};
